import Cache from "@/cache/product.js";     //引入商品缓存，用于存放商品编辑的内容和数据结构
import SaveProductQueue from "@/cache/saveProductQueue.js";     //引入商品缓存，用于存放商品编辑的内容和数据结构
import Api from '@/script/api';
import Message from '@/script/Message'
import Vue from 'vue';
// 新增模块
import IDB from '@/db/index.js';
import Call from '@/script/call'; // 文件处理
import { fetchDouDianAccounts } from '@/script/doudianLocalLogin';
import {
    applyUserPriceLocks,
    clearUserPriceLocksMany,
    loadUserPriceLocksByItemId,
    stripSourceJsonForRemote,
    typeItemIdFromPtype,
    getTypeItemId,
} from '@/script/skuPriceLockLocal.js';
let timers = null;          // 定时器对象
let lock = false;
/** 列表改标题：同一商品只认最后一次，避免慢请求把新标题盖掉 */
const listTitleSaveSeq = new Map();

function clampTitleByte(val, max = 60) {
    const str = val == null ? "" : String(val);
    let len = 0;
    let result = "";
    for (const char of str) {
        const charLen = /[\u4e00-\u9fa5]/.test(char) ? 2 : 1;
        if (len + charLen > max) break;
        result += char;
        len += charLen;
    }
    return result;
}

/** 数据包导入等场景：避免因 id 为字符串/大数字等导致 `> 0` 判断失败，记录无法进入 jumpProduct */
function isJumpProductRecordable(product) {
    if (!product) return false;
    const nonempty = (v) => v != null && String(v).trim() !== "";
    return nonempty(product.itemId) || nonempty(product.id);
}

function skuPriceShopIdOf(item) {
    if (!item) return "";
    if (item.shop_id != null && item.shop_id !== "") return item.shop_id;
    if (item.shop && item.shop.id != null && item.shop.id !== "") return item.shop.id;
    return "";
}

function skuPriceRowKey(item) {
    return String(skuPriceShopIdOf(item)) + "-" + String(item && item.product_id != null ? item.product_id : "");
}

function findSkuPriceProductIndex(list, log) {
    if (!Array.isArray(list) || !log) return -1;
    const key = log._rowKey || skuPriceRowKey(log);
    if (key && key !== "-") {
        const byKey = list.findIndex((it) => (it._rowKey || skuPriceRowKey(it)) === key);
        if (byKey > -1) return byKey;
    }
    const shopId = skuPriceShopIdOf(log);
    if (shopId !== "") {
        return list.findIndex(
            (it) =>
                String(it.product_id) === String(log.product_id) &&
                String(skuPriceShopIdOf(it)) === String(shopId),
        );
    }
    return list.findIndex((it) => it.product_id == log.product_id);
}

const state = {
    copyConfig: getBaseConfig('cache/publish.json'),
    readConfig: getBaseConfig(),
    copyLog: [],

    copyLinkValue: "",  //要抓取的链接
    product: [],        //宝贝列表
    jumpProduct: [],    //跳过列表

    loading: false,                 //显示加载状态
    imageUploadLockDepth: 0,        //主图/详情图 ImageUploader 并发上传计数，>0 时禁止切换商品
    editIndex: -1,                  //编辑的宝贝索引
    lastEditIndex: null,             //上一次编辑的索引
    hasEdited: false,               //编辑的宝贝对象
    cacheDetail: null,              //缓存文件里面的详情，用于编辑商品的时候

    startTimestamp: null,           // 记录开始时间戳
    copyTime: 0,                    //总的上架时间

    //图片选择器对象
    imgSelect: {
        show: false,                //显示模态框
        filed: null,                //当前操作的字段
        type: 'add',                //操作类型，add：增加，reset：编辑
        owner: ""                   //宿主标识（"" 为精细化上架，dse 为抖店商品编辑）
    },

    selectShop: "",                 //选择的店铺 
    shopList: [],                   //店铺列表 用于抓取和上架
    copyShopIds: [],                //上架商品的店铺id列表

    readLinkUrls: [],               //要抓取的链接
    copyProductIds: [],             //要抓取的关系表id
    copyProductIdsBackup: [],             //要抓取的关系表id
    copyProductIdsIsFinish: false,    //copyProductIds队列是否初始化完成了,如果完成把这个标记位设置成true,node端读取就会开始判断什么时候应该执行上架完毕退出
    pddProducts: [], //拼多多解析数据
    pddFilterId: [],
    pddImportPath: "",

    selectTemp: "",                 //选择的模板
    tempList: [],                   //模板列表 用于抓取和上架
    catchType: 1,                    //1:普通抓取 2:强制抓取
    // 高级解析时可选保留旧图（默认均不保留）
    keepOldImages: {
        main: false,
        sku: false,
        desc: false,
    },
    banJiaProduct: [],               //搬家商品
    banJiaStatus: 0,                 //0.未开始  1.点击开始 2.进行中 3.点击停止 4.停止成功 5.运行完毕 6.店铺掉登
    shangjiaproduct: [],//商机列表
    shangjiForm: {  //商机条件筛选
        jiange: 4000,
        shangJiShopConcurrency: 3,
        /** 本地池商品创建时间近 N 天（7/14/30），默认 30，对齐抖爆单 */
        goodsCreateDays: 30,
        /** 不改标题：any=宽松 all=精准，默认 any */
        keywordMatchMode: "any",
        /** 可选商品 ID/标题/编码过滤，空=不限 */
        shangJiIdNameCode: "",
        /** 每商机最多提报条数，0=不限 */
        shangJiMaxGoodsPerClue: 0,
        activeMode: "byOpportunity",
        matchMode: "new",
        activeKeyword: "MATCH_DEGREE",
        shop: false,
        shopid: [],
        useAddedOpportunity: false,
        useAddedOpportunity2: false,
        opportunityInfo: "",
        category: "",
        reason: "",
        reason2: "",
        rights: [],
        rights2: [],
        brand: "",
        brand2: "",
        newTime: "",
        newTime2: "",
        style: [],
        style2: [],
        serviceTimes: "144",
        /** 增强版：多店拉商机 / 分词 / 每轮提报的有界并发，过大易触发限流 */
        shangJiEnhancedConcurrent: 3,
        /** 增强版（不修改标题）：单店累计成功提报达到该条数后该店退出多轮；默认 1000 */
        shangJiEnhancedSuccessCap: 1000,
        /** 增强版（不修改标题）：要执行的全局提报轮次，1～4 对应四轮规则；默认全开 */
        shangJiEnhancedPhases: [1, 2, 3, 4],
    },
    shangjiselection: [],//商机选中值，shangjiselection,shangjilog,shangjionsaleproducts,shangjiselectiononsale
    shangjistate: 0,//商机提交状态 0.未开始 1.准备开始 2.进行中 3.点击停止 4.停止成功 5.运行完毕 6.店铺掉登
    shangjilog: [], //商机日志列表
    shangJiCollectState: 0,//商机收藏状态（与提报独立）
    shangJiCollectLog: [], //商机收藏日志
    shangjionsaleproducts: [], //商机自家店铺商品列表
    shangjiselectiononsale: [],//选中的自家商品
    huaShop: [],//滑块店铺

    //批量修改标题
    titlestate: 0,//修改提交状态 0.未开始 1.准备开始 2.进行中 3.点击停止 4.停止成功 5.运行完毕 6.店铺掉登
    title_products: [],
    title_product_selects: [], //选中值
    /** 批量改标题·加载商品（0 未开始 1 准备 2 进行中 3 停止中 4 已停止 5 完毕） */
    titleLoadState: 0,
    titleLoadSnapshot: null,
    titleLoadProgress: { page: 0, pageCount: 0 },
    title_edit_rules: {//修改标题条件设置
        editMode: "auto",
        check: [
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
        ],
        aigen: "1",
        entype: "1",
        addPrefix: false,
        addPrefixPos: "after",
        rewriteTitle: true,
        rewriteWords: false,
        useNewContent: true,
        newContent3: "",
        newContent4: "",
        newContent71: [""],
        newContent72: [""],
        newContent82: "",
        newContent81: "",
        newContent91: 0,
        newContent92: 0,
        newContent101: "",
        newContent102: "",
        deleteKeywords: false,
        deleteKeywordsText: "",
        cleanOptions: [],
    },

    //批量修改 SKU 价格
    skuPricestate: 0,
    sku_price_products: [],
    sku_price_product_selects: [],
    skuPriceLoadState: 0,
    skuPriceLoadSnapshot: null,
    skuPriceLoadProgress: { page: 0, pageCount: 0, shopIndex: 0, shopCount: 0, shopName: "" },
    skuPricePreviewState: 0,
    skuPriceStep: 0,
    skuPriceActiveProductId: "",
    sku_price_edit_rules: {
        skuScope: "all",
        multiMinMode: "first",
        multiMaxMode: "first",
        exceptMinMode: "excludeAll",
        exceptMaxMode: "excludeAll",
        skuPriceMin: "",
        skuPriceMax: "",
        ruleMode: "fixed",
        fixedYuan: "",
        formulaPct: 100,
        formulaAdd: "",
        formulaSub: "",
        formulaFinalPct: 100,
        addsubOp: "add",
        addsubYuan: "",
        muldivOp: "mul",
        muldivValue: "",
        protectMode: "none",
        protectPercent: "",
        protectMinYuan: "",
        protectMaxYuan: "",
    },

    //批量修改短标题
    shorttitlestate: 0,//修改提交状态 0.未开始 1.准备开始 2.进行中 3.点击停止 4.停止成功 5.运行完毕 6.店铺掉登
    short_title_products: [],
    short_title_product_selects: [], //选中值
    shortTitleLoadState: 0,
    shortTitleLoadSnapshot: null,
    shortTitleLoadProgress: { page: 0, pageCount: 0 },
    short_title_edit_rules: {//短标修改条件
        op: true,
        editMode: "1",
        check: [
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
        ],
        value2: [],
        value3: "",
        value4: 10,
        value6: "",
        value7: [],
        value81: [""],
        value82: [""],
        value91: "",
        value92: "",
        value101: "",
        value102: "",
    },

    // 批量修改品牌
    brandstate: 0,// 修改提交状态 0.未开始 1.准备开始 2.进行中 3.点击停止 4.停止成功 5.运行完毕 6.店铺掉登
    brand_products: [],
    brand_product_selects: [],
    brandLoadState: 0,
    brandLoadSnapshot: null,
    brandLoadProgress: { page: 0, pageCount: 0 },
    brand_edit_rules: {
        // 与搬家 template.brand_type 一致：1 指定品牌（名称检索），2 软件自动匹配
        brand_type: 1,
        specifiedBrandName: "",
        concurrency: 10,
    },
    // 批量修改三包服务承诺
    aftersalestate: 0,
    aftersale_products: [],
    aftersale_product_selects: [],
    aftersaleLoadState: 0,
    aftersaleLoadSnapshot: null,
    aftersaleLoadProgress: { page: 0, pageCount: 0 },
    aftersale_edit_rules: {
        mandatory_service_type: 1,
        mandatory_duration: "",
        optional_mode: "",
        optional_duration: "",
    },
    // 批量修改类目属性
    attrstate: 0,// 修改提交状态 0.未开始 1.准备开始 2.进行中 3.点击停止 4.停止成功 5.运行完毕 6.店铺掉登
    attr_products: [],
    attr_product_selects: [],
    attr_edit_rules: {
        mode: "single",
        category: [],
        parentCategory: [],
        categoryLeafIds: [],
        change_attribute_json: {},
        categorySchemaMap: {},
        concurrency: 10,
    },
    // 批量修改面料材质(水洗标/吊牌图)
    fabricstate: 0,
    fabric_products: [],
    fabric_product_selects: [],
    fabric_edit_rules: {
        method: 1,
        modifyFabric: true,
        fabricRows: [{ name: "", percent: "" }],
        filterContainsEnabled: false,
        filterContains: "",
        filterEmptyOnly: false,
        modifyPic: false,
        picUrl: "",
        skipPicIfExists: true,
        fromName: "",
        toName: "",
    },

    // 批量修改运费模板
    freightstate: 0,
    freight_products: [],
    freight_product_selects: [],
    freight_edit_rules: {
        freight_id: "",
        concurrency: 10,
    },

    /** 按源链接批量下架/删除（0 未开始 1 准备 2 进行中 3 停止中 4 已停止 5 完毕） */
    offlineDeleteState: 0,
    offlineDeleteOpType: "",
    offlineDeleteEntry: "", // sourceLink | douItemId
    offlineDeleteDeleteCloud: false,
    offlineDeleteItems: [],
    offlineDeleteProgress: { total: 0, done: 0, success: 0, fail: 0 },

    /** 草稿箱·网页版批量上架（0 未开始 1 准备 2 进行中 3 停止 4 已停止 5 完毕） */
    draftsWebReleaseState: 0,
    draftsWebReleaseIds: [],
    draftsWebReleaseTab: "",
    draftsWebReleaseProgress: { total: 0, done: 0, success: 0, fail: 0 },

    /** 草稿箱·拉取同步（0 未开始 1 准备 2 进行中 3 停止 4 已停止 5 完毕） */
    draftsSyncState: 0,
    draftsSyncLogList: [],
    draftsSyncSnapshot: null,

    /** 批量处理违规·拉取同步（0 未开始 1 准备 2 进行中 3 停止 4 已停止 5 完毕） */
    violationBatchSyncState: 0,
    violationBatchSyncLogList: [],
    violationBatchSyncSnapshot: null,
    /** 批量诊断违规页 UI 缓存（切页返回恢复） */
    violationBatchPageCache: null,

    /** 清理滞销：步骤 1|2 */
    deadStockStep: 1,
    /** 分析状态 0 未开始 1 准备 2 进行中 3 停止 4 已停止 5 完毕 */
    deadStockAnalyzeState: 0,
    /** 批量操作状态 0 未开始 1 准备 2 进行中 3 停止 4 已停止 5 完毕 */
    deadStockBatchState: 0,
    deadStockConfig: null,
    deadStockDeadList: [],
    deadStockNonDeadList: [],
    deadStockLastAnalyzeAt: "",
    deadStockAnalyzeProgress: {
        total: 0,
        done: 0,
        shopName: "",
        msg: "",
        error: "",
        rateLimited: false,
        rateLimitMsg: "",
    },
    deadStockBatchProgress: {
        total: 0,
        done: 0,
        success: 0,
        fail: 0,
        phase: "",
        checking: 0,
        checkTotal: 0,
        msg: "",
    },

    /** 清理低质商品：拉取状态 0 未开始 1 准备 2 进行中 3 停止 4 已停止 5 完毕 */
    lowQualityFetchState: 0,
    /** 清理低质商品：批量下架状态 */
    lowQualityBatchState: 0,
    lowQualityList: [],
    lowQualityLastFetchAt: "",
    lowQualityFetchProgress: { total: 0, done: 0, shopName: "", msg: "", error: "" },
    lowQualityBatchProgress: { total: 0, done: 0, success: 0, fail: 0 },
    /** 商品质量诊断清理：拉取状态 0 未开始 1 准备 2 进行中 3 停止 4 已停止 5 完毕 */
    qualityDiagnoseFetchState: 0,
    /** 商品质量诊断清理：批量下架/删除状态 */
    qualityDiagnoseBatchState: 0,
    qualityDiagnoseList: [],
    qualityDiagnoseLastFetchAt: "",
    qualityDiagnoseFetchProgress: { total: 0, done: 0, shopName: "", msg: "", error: "" },
    qualityDiagnoseBatchProgress: { total: 0, done: 0, success: 0, fail: 0 },

    /** 定时清理低质：最近一次提醒/结果（worker 推送） */
    lowQualityScheduleNotify: {
        phase: "",
        level: "",
        msg: "",
        last_run_at: 0,
        last_run_msg: "",
        success: 0,
        fail: 0,
        skipped: 0,
        auth_fail: 0,
    },

    /** 限时限量购（单品直降）活动创建 */
    flashsalestate: 0,
    /** 限时限量购·创建活动进度（全局，切换页面不丢；与商机提报 shangjistate 同思路） */
    flashsaleCreateDialogVisible: false,
    flashsaleCreateProgressTotal: 0,
    flashsaleCreateProgressDone: 0,
    flashsaleCreateSuccessCount: 0,
    flashsaleCreateFailCount: 0,
    flashsaleCreateResultSeq: 0,
    flashsaleCreateResults: [],
    flashsaleCreateFailReasons: [],
    /** 用户请求停止创建活动（runner 内轮询此标志） */
    flashsaleCreateStopRequested: false,
    flashsale_products: [],
    flashsale_product_selects: [],
    /** 限时限量购「加载商品」全局状态（切换页面后继续，组件读 store） */
    flashsale_load_running: false,
    flashsale_load_status_text: "",
    flashsale_load_page_info: {
        day: 0,
        dayCount: 0,
        dayPage: 0,
        dayPageCount: 0,
        scanned: 0,
        eligible: 0,
        /** scan | flush | pool */
        phase: "",
        scanEligible: 0,
        poolPage: 0,
        poolPageMax: 100,
        poolCollected: 0,
        poolMerged: 0,
    },
    /** 每次加载启动 / 取消递增，循环用 currentGen===gen 判断是否仍是本次任务 */
    flashsale_load_gen: 0,
    /** 用户请求停止：1 表示需要立即终止当前加载 */
    flashsale_load_stop_flag: 0,
    /** 用户当前选择的店铺 id 集合（切换页面持久） */
    flashsale_selected_shop_ids: [],
    /**
     * 「按店」整次扫描结果缓存：{ [shopId|biz|t0|t1]: { products: [...], at: ms } }
     * 30 分钟内同条件再次加载直接 append 到结果，无 IPC、真正秒开
     */
    flashsale_shop_scan_cache: {},
    flashsale_edit_form: {
        business_code: "LimitTime",
        datetimeRange: null,
        productsPerBatch: 200,
        activity_limit_mode: "limited",
        limit_num_type: 1,
        /** 活动限量：计算方式（all_stock | percent_stock | fixed_stock） */
        // 选择「限量」时默认：统一库存 100 件
        activity_limit_calc_mode: "fixed_stock",
        activity_limit_percent: 50,
        activity_limit_fixed_num: 100,
        // 百分比库存时：默认限量 100 件（库存为 0 时兜底）
        activity_limit_when_stock_zero: 100,
        /** 兼容旧字段：统一库存时使用 */
        activity_limit_num: 100,
        sold_out_type: "0",
        user_limit_mode: "limited",
        user_limit_num: 20,
        promo_mode: "discount_fixed",
        shop_stype: "3",
        discount_zhe: 9.5,
        direct_drop_yuan: 5.99,
        fixed_price_yuan: 20000,
        sku_scope: "all",
        /** 自动续期（仅「限量抢购」「普通降价促销」可配置；「限时抢购」始终为 false） */
        renew_switch_on: false,
        /** 自动将优惠价格压至 batch_query 返回的 15 天最低价（仅限时抢购/限量抢购） */
        auto_set_15d_low_price: false,
        title_mode: "random",
        title_prefix: "",
        order_expire_seconds: "1800",
        preheat_enabled: false,
        preheat_hours: 0.25,
        more_expand: false,
        /** 一口价（折扣）·区间价；false 为单行简版 */
        use_promo_price_intervals: false,
        promo_price_intervals: [
            {
                min_yuan: 0,
                max_yuan: 999999999,
                discount_zhe: 9.5,
                direct_drop_yuan: 0,
                user_limit: 20,
            },
        ],
        /** 一口价（定价）·区间价；false 为单行简版 */
        use_price_fixed_intervals: false,
        price_fixed_intervals: [
            {
                min_yuan: 0,
                max_yuan: 999999999,
                fixed_price_yuan: 20000,
                user_limit: 20,
            },
        ],
        /** 直降 · 区间价；false 为单行简版 */
        use_direct_drop_intervals: false,
        direct_drop_intervals: [
            {
                min_yuan: 0,
                max_yuan: 999999999,
                direct_drop_yuan: 5.99,
                user_limit: 20,
            },
        ],
        /** 打折 · 区间价；false 为单行简版 */
        use_discount_only_intervals: false,
        discount_only_intervals: [
            {
                min_yuan: 0,
                max_yuan: 999999999,
                discount_zhe: 9.5,
                user_limit: 20,
            },
        ],
        /** 最低价 SKU 单独设置 */
        enable_lowest_sku_override: false,
        lowest_sku_pick_mode: "first", // first | last | random | all
        lowest_discount_zhe: 9.5,
        lowest_direct_drop_yuan: 5.99,
        lowest_fixed_price_yuan: 0,
        lowest_user_limit: 20,
    },
}

const mutations = {
    //设置短标条件
    setShortTitleEditRule(state, form) {
        state.short_title_edit_rules = Object.assign(state.short_title_edit_rules, form);
    },
    //设置批量修短改标题运行结果
    setBatchEditShortTitleResult(state, log) {
        let idx = state.short_title_products.findIndex(it => it.product_id == log.product_id);
        if (idx > -1) {
            state.short_title_products[idx] = Object.assign(state.short_title_products[idx], log);
        }
    },
    //批量设置修改短标题商品
    setShortTitleProducts: function (state, sproducts) {
        state.short_title_products = sproducts;
    },
    setShortTitleLoadState(state, value) {
        state.shortTitleLoadState = value;
    },
    setShortTitleLoadSnapshot(state, payload) {
        state.shortTitleLoadSnapshot = payload ? Object.assign({}, payload) : null;
    },
    setShortTitleLoadProgress(state, payload) {
        state.shortTitleLoadProgress = Object.assign({}, state.shortTitleLoadProgress, payload || {});
    },
    resetShortTitleLoadProgress(state) {
        state.shortTitleLoadProgress = { page: 0, pageCount: 0 };
    },
    //设置批量修改短标题状态
    setShortTitleState(state, value) {
        state.shorttitlestate = value;
    },
    //设置批量修改短标题选中数据
    setShortTitleProductSelects(state, sproducts) {
        state.short_title_product_selects = sproducts;
    },
    //新增批量修改短标题选中数据
    addShortTitleProductSelects(state, sproduct) {
        let find = state.short_title_product_selects.find(it => it.product_id == sproduct.product_id)
        if (!find) {
            state.short_title_product_selects.push(sproduct);
        }
    },
    //删除短
    delShortTitleProductSelects(state, sproduct) {
        const index = state.short_title_product_selects.findIndex(obj => obj.product_id === sproduct.product_id);
        if (index !== -1) {
            state.short_title_product_selects.splice(index, 1);
        }
    },

    setOfflineDeleteState(state, value) {
        state.offlineDeleteState = value;
    },
    setOfflineDeleteOpType(state, value) {
        state.offlineDeleteOpType = value;
    },
    setOfflineDeleteEntry(state, value) {
        state.offlineDeleteEntry = value || "";
    },
    setOfflineDeleteDeleteCloud(state, value) {
        state.offlineDeleteDeleteCloud = !!value;
    },
    setOfflineDeleteItems(state, items) {
        state.offlineDeleteItems = Array.isArray(items) ? items : [];
    },
    setOfflineDeleteProgress(state, payload) {
        state.offlineDeleteProgress = Object.assign({}, state.offlineDeleteProgress, payload);
    },
    resetOfflineDeleteProgress(state) {
        state.offlineDeleteProgress = { total: 0, done: 0, success: 0, fail: 0 };
    },
    setDraftsWebReleaseState(state, value) {
        state.draftsWebReleaseState = value;
    },
    setDraftsWebReleaseIds(state, ids) {
        state.draftsWebReleaseIds = Array.isArray(ids) ? ids : [];
    },
    setDraftsWebReleaseTab(state, tab) {
        state.draftsWebReleaseTab = tab || "";
    },
    setDraftsWebReleaseProgress(state, payload) {
        state.draftsWebReleaseProgress = Object.assign({}, state.draftsWebReleaseProgress, payload);
    },
    resetDraftsWebReleaseProgress(state, payload = {}) {
        state.draftsWebReleaseProgress = {
            total: payload.total || 0,
            done: 0,
            success: 0,
            fail: 0,
        };
    },
    setDraftsSyncState(state, value) {
        state.draftsSyncState = value;
    },
    appendDraftsSyncLog(state, msg) {
        state.draftsSyncLogList = [...state.draftsSyncLogList, String(msg)];
    },
    resetDraftsSyncLog(state) {
        state.draftsSyncLogList = [];
    },
    setDraftsSyncSnapshot(state, payload) {
        state.draftsSyncSnapshot = payload ? Object.assign({}, payload) : null;
    },
    setViolationBatchSyncState(state, value) {
        state.violationBatchSyncState = value;
    },
    appendViolationBatchSyncLog(state, msg) {
        state.violationBatchSyncLogList = [...state.violationBatchSyncLogList, String(msg)];
    },
    resetViolationBatchSyncLog(state) {
        state.violationBatchSyncLogList = [];
    },
    setViolationBatchSyncSnapshot(state, payload) {
        state.violationBatchSyncSnapshot = payload ? Object.assign({}, payload) : null;
    },
    setViolationBatchPageCache(state, payload) {
        state.violationBatchPageCache = payload ? Object.assign({}, payload) : null;
    },
    resetOfflineDeleteRelRun(state) {
        for (let i = 0; i < state.offlineDeleteItems.length; i++) {
            const it = state.offlineDeleteItems[i];
            if (!it.rels || !it.rels.length) continue;
            const rels = it.rels.map((r) =>
                Object.assign({}, r, { run_status: 0, run_msg: "" }),
            );
            state.offlineDeleteItems.splice(
                i,
                1,
                Object.assign({}, it, {
                    rels,
                    cloud_status: 0,
                    cloud_msg: "",
                }),
            );
        }
    },
    setDeadStockStep(state, v) {
        state.deadStockStep = v === 2 ? 2 : 1;
    },
    setDeadStockAnalyzeState(state, value) {
        state.deadStockAnalyzeState = value;
    },
    setDeadStockBatchState(state, value) {
        state.deadStockBatchState = value;
    },
    setDeadStockConfig(state, config) {
        state.deadStockConfig = config ? Object.assign({}, config) : null;
    },
    setDeadStockLists(state, payload) {
        if (Array.isArray(payload.dead)) {
            state.deadStockDeadList = payload.dead;
        }
        if (Array.isArray(payload.nonDead)) {
            state.deadStockNonDeadList = payload.nonDead;
        }
        if (payload.lastAnalyzeAt != null) {
            state.deadStockLastAnalyzeAt = payload.lastAnalyzeAt;
        }
    },
    appendDeadStockAnalyzeItem(state, payload) {
        const row = Object.assign(
            {
                _rowKey: payload._rowKey || payload.shop_id + "-" + payload.product_id,
                checked: false,
            },
            payload,
        );
        if (payload.isDead) {
            state.deadStockDeadList.push(row);
        } else {
            state.deadStockNonDeadList.push(row);
        }
    },
    setDeadStockCheckedBatch(state, { rowKeys, checked }) {
        const set = new Set((rowKeys || []).map(String));
        const go = (list) => {
            for (let i = 0; i < list.length; i++) {
                if (set.has(String(list[i]._rowKey))) {
                    list.splice(i, 1, Object.assign({}, list[i], { checked: !!checked }));
                }
            }
        };
        go(state.deadStockDeadList);
        go(state.deadStockNonDeadList);
    },
    resetDeadStockLists(state) {
        state.deadStockDeadList = [];
        state.deadStockNonDeadList = [];
    },
    setDeadStockAnalyzeProgress(state, payload) {
        state.deadStockAnalyzeProgress = Object.assign({}, state.deadStockAnalyzeProgress, payload);
    },
    resetDeadStockAnalyzeProgress(state) {
        state.deadStockAnalyzeProgress = {
            total: 0,
            done: 0,
            shopName: "",
            msg: "",
            error: "",
            rateLimited: false,
            rateLimitMsg: "",
        };
    },
    setDeadStockBatchProgress(state, payload) {
        state.deadStockBatchProgress = Object.assign({}, state.deadStockBatchProgress, payload);
    },
    resetDeadStockBatchProgress(state) {
        state.deadStockBatchProgress = {
            total: 0,
            done: 0,
            success: 0,
            fail: 0,
            phase: "",
            checking: 0,
            checkTotal: 0,
            msg: "",
        };
    },
    setDeadStockBatchResult(state, payload) {
        const pid = String(payload.product_id);
        const sid = String(payload.shop_id);
        const patch = {
            run_status: payload.run_status,
            run_msg: payload.run_msg || "",
        };
        const touch = (list) => {
            const idx = list.findIndex(
                (it) => String(it.product_id) === pid && String(it.shop_id) === sid,
            );
            if (idx >= 0) {
                list.splice(idx, 1, Object.assign({}, list[idx], patch));
            }
        };
        touch(state.deadStockDeadList);
        touch(state.deadStockNonDeadList);
    },
    resetDeadStockBatchRun(state) {
        const reset = (list) => {
            for (let i = 0; i < list.length; i++) {
                list.splice(i, 1, Object.assign({}, list[i], { run_status: 0, run_msg: "" }));
            }
        };
        reset(state.deadStockDeadList);
        reset(state.deadStockNonDeadList);
    },

    setLowQualityFetchState(state, value) {
        state.lowQualityFetchState = value;
    },
    setLowQualityBatchState(state, value) {
        state.lowQualityBatchState = value;
    },
    setLowQualityList(state, payload) {
        if (Array.isArray(payload.list)) {
            state.lowQualityList = payload.list;
        }
        if (payload.lastFetchAt != null) {
            state.lowQualityLastFetchAt = payload.lastFetchAt;
        }
    },
    appendLowQualityItem(state, payload) {
        const row = Object.assign(
            {
                checked: false,
                run_status: 0,
                run_msg: "",
            },
            payload,
        );
        const idx = state.lowQualityList.findIndex((it) => it._rowKey === row._rowKey);
        if (idx >= 0) {
            state.lowQualityList.splice(idx, 1, Object.assign({}, state.lowQualityList[idx], row));
        } else {
            state.lowQualityList.push(row);
        }
    },
    resetLowQualityList(state) {
        state.lowQualityList = [];
    },
    setLowQualityCheckedBatch(state, { rowKeys, checked }) {
        const set = new Set((rowKeys || []).map(String));
        for (let i = 0; i < state.lowQualityList.length; i++) {
            const row = state.lowQualityList[i];
            if (set.has(String(row._rowKey))) {
                state.lowQualityList.splice(i, 1, Object.assign({}, row, { checked: !!checked }));
            }
        }
    },
    setLowQualityFetchProgress(state, payload) {
        state.lowQualityFetchProgress = Object.assign({}, state.lowQualityFetchProgress, payload);
    },
    resetLowQualityFetchProgress(state) {
        state.lowQualityFetchProgress = { total: 0, done: 0, shopName: "", msg: "", error: "" };
    },
    setLowQualityBatchProgress(state, payload) {
        state.lowQualityBatchProgress = Object.assign({}, state.lowQualityBatchProgress, payload);
    },
    resetLowQualityBatchProgress(state) {
        state.lowQualityBatchProgress = { total: 0, done: 0, success: 0, fail: 0 };
    },
    setLowQualityBatchResult(state, payload) {
        const pid = String(payload.product_id);
        const sid = String(payload.shop_id);
        const idx = state.lowQualityList.findIndex(
            (it) => String(it.product_id) === pid && String(it.shop_id) === sid,
        );
        if (idx >= 0) {
            state.lowQualityList.splice(
                idx,
                1,
                Object.assign({}, state.lowQualityList[idx], {
                    run_status: payload.run_status,
                    run_msg: payload.run_msg || "",
                }),
            );
        }
    },
    setLowQualityScheduleNotify(state, payload) {
        const src = payload && typeof payload === "object" ? payload : {};
        state.lowQualityScheduleNotify = {
            phase: String(src.phase || ""),
            level: String(src.level || ""),
            msg: String(src.msg || ""),
            last_run_at: parseInt(src.last_run_at, 10) || 0,
            last_run_msg: String(src.last_run_msg || src.msg || ""),
            success: parseInt(src.success, 10) || 0,
            fail: parseInt(src.fail, 10) || 0,
            skipped: parseInt(src.skipped, 10) || 0,
            auth_fail: parseInt(src.auth_fail, 10) || 0,
        };
    },
    resetLowQualityBatchRun(state) {
        for (let i = 0; i < state.lowQualityList.length; i++) {
            state.lowQualityList.splice(
                i,
                1,
                Object.assign({}, state.lowQualityList[i], { run_status: 0, run_msg: "" }),
            );
        }
    },

    setQualityDiagnoseFetchState(state, value) {
        state.qualityDiagnoseFetchState = value;
    },
    setQualityDiagnoseBatchState(state, value) {
        state.qualityDiagnoseBatchState = value;
    },
    setQualityDiagnoseList(state, payload) {
        if (Array.isArray(payload.list)) {
            state.qualityDiagnoseList = payload.list;
        }
        if (payload.lastFetchAt != null) {
            state.qualityDiagnoseLastFetchAt = payload.lastFetchAt;
        }
    },
    appendQualityDiagnoseItem(state, payload) {
        const row = Object.assign(
            {
                checked: false,
                run_status: 0,
                run_msg: "",
            },
            payload,
        );
        const idx = state.qualityDiagnoseList.findIndex((it) => it._rowKey === row._rowKey);
        if (idx >= 0) {
            state.qualityDiagnoseList.splice(idx, 1, Object.assign({}, state.qualityDiagnoseList[idx], row));
        } else {
            state.qualityDiagnoseList.push(row);
        }
    },
    resetQualityDiagnoseList(state) {
        state.qualityDiagnoseList = [];
    },
    setQualityDiagnoseFetchProgress(state, payload) {
        state.qualityDiagnoseFetchProgress = Object.assign({}, state.qualityDiagnoseFetchProgress, payload);
    },
    resetQualityDiagnoseFetchProgress(state) {
        state.qualityDiagnoseFetchProgress = { total: 0, done: 0, shopName: "", msg: "", error: "" };
    },
    setQualityDiagnoseBatchProgress(state, payload) {
        state.qualityDiagnoseBatchProgress = Object.assign({}, state.qualityDiagnoseBatchProgress, payload);
    },
    resetQualityDiagnoseBatchProgress(state) {
        state.qualityDiagnoseBatchProgress = { total: 0, done: 0, success: 0, fail: 0 };
    },
    setQualityDiagnoseBatchResult(state, payload) {
        const pid = String(payload.product_id);
        const sid = String(payload.shop_id);
        const idx = state.qualityDiagnoseList.findIndex(
            (it) => String(it.product_id) === pid && String(it.shop_id) === sid,
        );
        if (idx >= 0) {
            state.qualityDiagnoseList.splice(
                idx,
                1,
                Object.assign({}, state.qualityDiagnoseList[idx], {
                    run_status: payload.run_status,
                    run_msg: payload.run_msg || "",
                }),
            );
        }
    },
    resetQualityDiagnoseBatchRun(state) {
        for (let i = 0; i < state.qualityDiagnoseList.length; i++) {
            state.qualityDiagnoseList.splice(
                i,
                1,
                Object.assign({}, state.qualityDiagnoseList[i], { run_status: 0, run_msg: "" }),
            );
        }
    },

    /** Worker IPC：phase parse | run | cloud */
    setBatchOfflineDeleteResult(state, payload) {
        const { phase, source_item_id, source, source_url } = payload;
        const idx = state.offlineDeleteItems.findIndex(
            (it) =>
                String(it.source_item_id) === String(source_item_id) &&
                Number(it.source) === Number(source) &&
                String(it.source_url || "") === String(source_url || ""),
        );
        if (idx < 0) return;
        const row = state.offlineDeleteItems[idx];
        if (phase === "parse") {
            state.offlineDeleteItems.splice(
                idx,
                1,
                Object.assign({}, row, {
                    parse_status: payload.parse_status,
                    parse_msg: payload.parse_msg || "",
                    title: payload.title || "",
                    rels: Array.isArray(payload.rels)
                        ? payload.rels.map((r) => Object.assign({}, r))
                        : [],
                }),
            );
        } else if (phase === "run") {
            const rels = (row.rels || []).map((r) => {
                if (String(r.dou_item_id) === String(payload.dou_item_id)) {
                    return Object.assign({}, r, {
                        run_status: payload.run_status,
                        run_msg: payload.run_msg || "",
                    });
                }
                return r;
            });
            state.offlineDeleteItems.splice(idx, 1, Object.assign({}, row, { rels }));
        } else if (phase === "cloud") {
            state.offlineDeleteItems.splice(
                idx,
                1,
                Object.assign({}, row, {
                    cloud_status: payload.cloud_status,
                    cloud_msg: payload.cloud_msg || "",
                }),
            );
        }
    },

    setBrandEditRule(state, form) {
        state.brand_edit_rules = Object.assign(state.brand_edit_rules, form);
    },
    setBatchEditBrandResult(state, log) {
        let idx = state.brand_products.findIndex(it => it.product_id == log.product_id);
        if (idx > -1) {
            state.brand_products[idx] = Object.assign(state.brand_products[idx], log);
        }
    },
    setBrandProducts: function (state, sproducts) {
        state.brand_products = sproducts;
    },
    setBrandLoadState(state, value) {
        state.brandLoadState = value;
    },
    setBrandLoadSnapshot(state, payload) {
        state.brandLoadSnapshot = payload ? Object.assign({}, payload) : null;
    },
    setBrandLoadProgress(state, payload) {
        state.brandLoadProgress = Object.assign({}, state.brandLoadProgress, payload || {});
    },
    resetBrandLoadProgress(state) {
        state.brandLoadProgress = { page: 0, pageCount: 0 };
    },
    setBrandState(state, value) {
        state.brandstate = value;
    },
    setBrandProductSelects(state, sproducts) {
        state.brand_product_selects = sproducts;
    },
    addBrandProductSelects(state, sproduct) {
        let find = state.brand_product_selects.find(it => it.product_id == sproduct.product_id)
        if (!find) {
            state.brand_product_selects.push(sproduct);
        }
    },
    delBrandProductSelects(state, sproduct) {
        const index = state.brand_product_selects.findIndex(obj => obj.product_id === sproduct.product_id);
        if (index !== -1) {
            state.brand_product_selects.splice(index, 1);
        }
    },
    setAftersaleEditRule(state, form) {
        state.aftersale_edit_rules = Object.assign(state.aftersale_edit_rules, form);
    },
    setBatchEditAftersaleResult(state, log) {
        let idx = state.aftersale_products.findIndex(it => it.product_id == log.product_id);
        if (idx > -1) {
            state.aftersale_products[idx] = Object.assign(state.aftersale_products[idx], log);
        }
    },
    setAftersaleProducts: function (state, sproducts) {
        state.aftersale_products = sproducts;
    },
    setAftersaleLoadState(state, value) {
        state.aftersaleLoadState = value;
    },
    setAftersaleLoadSnapshot(state, payload) {
        state.aftersaleLoadSnapshot = payload ? Object.assign({}, payload) : null;
    },
    setAftersaleLoadProgress(state, payload) {
        state.aftersaleLoadProgress = Object.assign({}, state.aftersaleLoadProgress, payload || {});
    },
    resetAftersaleLoadProgress(state) {
        state.aftersaleLoadProgress = { page: 0, pageCount: 0 };
    },
    setAftersaleState(state, value) {
        state.aftersalestate = value;
    },
    setAftersaleProductSelects(state, sproducts) {
        state.aftersale_product_selects = sproducts;
    },
    addAftersaleProductSelects(state, sproduct) {
        let find = state.aftersale_product_selects.find(it => it.product_id == sproduct.product_id)
        if (!find) {
            state.aftersale_product_selects.push(sproduct);
        }
    },
    delAftersaleProductSelects(state, sproduct) {
        const index = state.aftersale_product_selects.findIndex(obj => obj.product_id === sproduct.product_id);
        if (index !== -1) {
            state.aftersale_product_selects.splice(index, 1);
        }
    },
    setAttrEditRule(state, form) {
        state.attr_edit_rules = Object.assign(state.attr_edit_rules, form);
    },
    setBatchEditAttrResult(state, log) {
        let idx = state.attr_products.findIndex(it => it.product_id == log.product_id);
        if (idx > -1) {
            state.attr_products[idx] = Object.assign(state.attr_products[idx], log);
        }
    },
    setAttrProducts: function (state, sproducts) {
        state.attr_products = sproducts;
    },
    setAttrState(state, value) {
        state.attrstate = value;
    },
    setAttrProductSelects(state, sproducts) {
        state.attr_product_selects = sproducts;
    },
    addAttrProductSelects(state, sproduct) {
        let find = state.attr_product_selects.find(it => it.product_id == sproduct.product_id)
        if (!find) {
            state.attr_product_selects.push(sproduct);
        }
    },
    delAttrProductSelects(state, sproduct) {
        const index = state.attr_product_selects.findIndex(obj => obj.product_id === sproduct.product_id);
        if (index !== -1) {
            state.attr_product_selects.splice(index, 1);
        }
    },

    setFabricEditRule(state, form) {
        state.fabric_edit_rules = Object.assign(state.fabric_edit_rules, form);
    },
    setBatchEditFabricResult(state, log) {
        let idx = state.fabric_products.findIndex(it => it.product_id == log.product_id);
        if (idx > -1) {
            state.fabric_products[idx] = Object.assign(state.fabric_products[idx], log);
        }
    },
    setFabricProducts(state, sproducts) {
        state.fabric_products = sproducts;
    },
    setFabricState(state, value) {
        state.fabricstate = value;
    },
    setFabricProductSelects(state, sproducts) {
        state.fabric_product_selects = sproducts;
    },
    addFabricProductSelects(state, sproduct) {
        let find = state.fabric_product_selects.find(it => it.product_id == sproduct.product_id);
        if (!find) {
            state.fabric_product_selects.push(sproduct);
        }
    },
    delFabricProductSelects(state, sproduct) {
        const index = state.fabric_product_selects.findIndex(
            (obj) => obj.product_id == sproduct.product_id,
        );
        if (index !== -1) {
            state.fabric_product_selects.splice(index, 1);
        }
    },

    setFreightEditRule(state, form) {
        state.freight_edit_rules = Object.assign(state.freight_edit_rules, form);
    },
    setBatchEditFreightResult(state, log) {
        let idx = state.freight_products.findIndex(it => it.product_id == log.product_id);
        if (idx > -1) {
            state.freight_products[idx] = Object.assign(state.freight_products[idx], log);
        }
    },
    setFreightProducts(state, sproducts) {
        state.freight_products = sproducts;
    },
    setFreightState(state, value) {
        state.freightstate = value;
    },
    setFreightProductSelects(state, sproducts) {
        state.freight_product_selects = sproducts;
    },
    addFreightProductSelects(state, sproduct) {
        let find = state.freight_product_selects.find(it => it.product_id == sproduct.product_id);
        if (!find) {
            state.freight_product_selects.push(sproduct);
        }
    },
    delFreightProductSelects(state, sproduct) {
        const index = state.freight_product_selects.findIndex(
            (obj) => obj.product_id == sproduct.product_id,
        );
        if (index !== -1) {
            state.freight_product_selects.splice(index, 1);
        }
    },

    setFlashsaleEditRule(state, form) {
        const t = state.flashsale_edit_form;
        Object.keys(form).forEach((k) => {
            Vue.set(t, k, form[k]);
        });
    },
    setFlashsaleProducts(state, list) {
        state.flashsale_products = list;
    },
    /** 增量追加（按 _rowId 去重），用于「加载商品」边拉边显示 */
    appendFlashsaleProducts(state, rows) {
        if (!Array.isArray(rows) || !rows.length) return;
        const cur = state.flashsale_products || [];
        const set = new Set();
        for (let i = 0; i < cur.length; i++) set.add(cur[i]._rowId);
        const next = cur.slice();
        for (let i = 0; i < rows.length; i++) {
            const r = rows[i];
            if (!r || !r._rowId) continue;
            if (set.has(r._rowId)) continue;
            set.add(r._rowId);
            next.push(r);
        }
        state.flashsale_products = next;
    },
    setFlashsaleSelectedShopIds(state, ids) {
        state.flashsale_selected_shop_ids = Array.isArray(ids)
            ? ids.map((id) => String(id))
            : [];
    },
    /** 写入单店整次扫描结果（自动清理过期 / 兜底上限） */
    setFlashsaleShopScanCache(state, payload) {
        if (!payload || !payload.key) return;
        const ttl = 30 * 60 * 1000;
        const max = 200;
        const now = Date.now();
        const next = {};
        const cache = state.flashsale_shop_scan_cache || {};
        const keys = Object.keys(cache);
        for (let i = 0; i < keys.length; i++) {
            const k = keys[i];
            if (now - cache[k].at <= ttl) next[k] = cache[k];
        }
        next[payload.key] = {
            products: Array.isArray(payload.products) ? payload.products : [],
            at: now,
        };
        const fresh = Object.keys(next);
        if (fresh.length > max) {
            fresh.sort((a, b) => next[a].at - next[b].at);
            const drop = fresh.length - max;
            for (let j = 0; j < drop; j++) delete next[fresh[j]];
        }
        state.flashsale_shop_scan_cache = next;
    },
    clearFlashsaleShopScanCache(state) {
        state.flashsale_shop_scan_cache = {};
    },
    setFlashsaleLoadRunning(state, v) {
        state.flashsale_load_running = !!v;
    },
    setFlashsaleLoadStatusText(state, t) {
        state.flashsale_load_status_text = t == null ? "" : String(t);
    },
    patchFlashsaleLoadPageInfo(state, partial) {
        state.flashsale_load_page_info = Object.assign(
            {},
            state.flashsale_load_page_info,
            partial || {},
        );
    },
    resetFlashsaleLoadPageInfo(state) {
        state.flashsale_load_page_info = {
            day: 0,
            dayCount: 0,
            dayPage: 0,
            dayPageCount: 0,
            scanned: 0,
            eligible: 0,
            phase: "",
            scanEligible: 0,
            poolPage: 0,
            poolPageMax: 100,
            poolCollected: 0,
            poolMerged: 0,
        };
    },
    bumpFlashsaleLoadGen(state) {
        state.flashsale_load_gen = (Number(state.flashsale_load_gen) || 0) + 1;
    },
    setFlashsaleLoadStopFlag(state, v) {
        state.flashsale_load_stop_flag = v ? 1 : 0;
    },
    setFlashsaleState(state, value) {
        state.flashsalestate = value;
    },
    setFlashsaleProductSelects(state, rows) {
        state.flashsale_product_selects = rows;
    },
    addFlashsaleProductSelects(state, row) {
        const id = row._rowId;
        let find = state.flashsale_product_selects.find(it => it._rowId === id);
        if (!find) {
            state.flashsale_product_selects.push({ _rowId: id, product_id: row.product_id, shop_id: row.shop_id });
        }
    },
    delFlashsaleProductSelects(state, row) {
        const id = row._rowId;
        const index = state.flashsale_product_selects.findIndex(obj => obj._rowId === id);
        if (index !== -1) {
            state.flashsale_product_selects.splice(index, 1);
        }
    },

    setFlashsaleCreateDialogVisible(state, v) {
        state.flashsaleCreateDialogVisible = !!v;
    },
    startFlashsaleCreateJob(state, { total }) {
        state.flashsaleCreateProgressTotal = total;
        state.flashsaleCreateProgressDone = 0;
        state.flashsaleCreateSuccessCount = 0;
        state.flashsaleCreateFailCount = 0;
        state.flashsaleCreateResultSeq = 0;
        state.flashsaleCreateResults = [];
        state.flashsaleCreateFailReasons = [];
        state.flashsaleCreateStopRequested = false;
    },
    setFlashsaleCreateStopRequested(state, v) {
        state.flashsaleCreateStopRequested = !!v;
    },
    appendFlashsaleCreateOrphans(state, { orphans }) {
        for (let i = 0; i < orphans.length; i++) {
            const o = orphans[i];
            state.flashsaleCreateResults.push({
                _rowId: "cr" + state.flashsaleCreateResultSeq++,
                product_id: o.product_id,
                title: "",
                shop_name: o.shop_name,
                ok: false,
                message: "列表中找不到对应商品，请重新加载商品后再试",
            });
            state.flashsaleCreateFailCount++;
            state.flashsaleCreateProgressDone++;
        }
    },
    appendFlashsaleCreateBatch(state, { batch, shopName, ok, message }) {
        if (!batch || !batch.length) return;
        const msg = message != null ? String(message) : "";
        const sn = shopName != null ? String(shopName) : "";
        for (let i = 0; i < batch.length; i++) {
            const r = batch[i];
            state.flashsaleCreateResults.push({
                _rowId: "cr" + state.flashsaleCreateResultSeq++,
                product_id: r.product_id,
                title: (r.name || r.title || "").slice(0, 120),
                shop_name: sn,
                ok,
                message: msg,
            });
        }
        if (ok) state.flashsaleCreateSuccessCount += batch.length;
        else state.flashsaleCreateFailCount += batch.length;
        state.flashsaleCreateProgressDone += batch.length;
    },
    addFlashsaleCreateFailReason(state, reason) {
        if (reason != null && String(reason).trim() !== "") {
            state.flashsaleCreateFailReasons.push(String(reason).trim());
        }
    },

    //设置商机筛选条件
    setTitleEditRule(state, form) {
        state.title_edit_rules = Object.assign(state.title_edit_rules, form);
    },
    //设置批量修改标题运行结果
    setBatchEditTitleResult(state, log) {
        let idx = state.title_products.findIndex(it => it.product_id == log.product_id);
        if (idx > -1) {
            state.title_products[idx] = Object.assign(state.title_products[idx], log);
        }
    },
    //批量设置修改标题商品
    setTitleProducts: function (state, sproducts) {
        state.title_products = sproducts;
    },
    setTitleLoadState(state, value) {
        state.titleLoadState = value;
    },
    setTitleLoadSnapshot(state, payload) {
        state.titleLoadSnapshot = payload ? Object.assign({}, payload) : null;
    },
    setTitleLoadProgress(state, payload) {
        state.titleLoadProgress = Object.assign({}, state.titleLoadProgress, payload || {});
    },
    resetTitleLoadProgress(state) {
        state.titleLoadProgress = { page: 0, pageCount: 0 };
    },
    //设置批量修改标题状态
    setTitleState(state, value) {
        state.titlestate = value;
    },
    //设置批量修改标题选中数据
    setTitleProductSelects(state, sproducts) {
        state.title_product_selects = sproducts;
    },
    //新增批量修改标题选中数据
    addTitleProductSelects(state, sproduct) {
        let find = state.title_product_selects.find(it => it.product_id == sproduct.product_id)
        if (!find) {
            state.title_product_selects.push(sproduct);
        }
    },
    //删除
    delTitleProductSelects(state, sproduct) {
        const index = state.title_product_selects.findIndex(obj => obj.product_id === sproduct.product_id);
        if (index !== -1) {
            state.title_product_selects.splice(index, 1);
        }
    },

    setSkuPriceEditRule(state, form) {
        state.sku_price_edit_rules = Object.assign({}, state.sku_price_edit_rules, form || {});
    },
    setBatchEditSkuPriceResult(state, log) {
        const idx = findSkuPriceProductIndex(state.sku_price_products, log);
        if (idx > -1) {
            const next = Object.assign({}, state.sku_price_products[idx], log);
            if (!next._rowKey) {
                next._rowKey = skuPriceRowKey(next);
            }
            state.sku_price_products.splice(idx, 1, next);
        }
    },
    setSkuPriceProducts(state, sproducts) {
        const list = Array.isArray(sproducts) ? sproducts : [];
        for (let i = 0; i < list.length; i++) {
            const row = list[i];
            if (!row) continue;
            if (row.shop) {
                if (row.shop_id == null) row.shop_id = row.shop.id;
                if (!row.shop_name) row.shop_name = row.shop.shop_name;
            }
            if (!row._rowKey) {
                row._rowKey = skuPriceRowKey(row);
            }
        }
        state.sku_price_products = list;
    },
    setSkuPriceLoadState(state, value) {
        state.skuPriceLoadState = value;
    },
    setSkuPriceLoadSnapshot(state, payload) {
        state.skuPriceLoadSnapshot = payload ? Object.assign({}, payload) : null;
    },
    setSkuPriceLoadProgress(state, payload) {
        state.skuPriceLoadProgress = Object.assign({}, state.skuPriceLoadProgress, payload || {});
    },
    resetSkuPriceLoadProgress(state) {
        state.skuPriceLoadProgress = { page: 0, pageCount: 0, shopIndex: 0, shopCount: 0, shopName: "" };
    },
    setSkuPriceState(state, value) {
        state.skuPricestate = value;
    },
    setSkuPricePreviewState(state, value) {
        state.skuPricePreviewState = value;
    },
    setSkuPriceStep(state, value) {
        state.skuPriceStep = value;
    },
    setSkuPriceActiveProductId(state, value) {
        state.skuPriceActiveProductId = value != null ? String(value) : "";
    },
    setSkuPriceProductSelects(state, sproducts) {
        state.sku_price_product_selects = sproducts;
    },
    patchSkuPriceSku(state, { product_id, shop_id, _rowKey, key, patch }) {
        const idx = findSkuPriceProductIndex(state.sku_price_products, { product_id, shop_id, _rowKey });
        if (idx < 0) {
            return;
        }
        const product = state.sku_price_products[idx];
        const skus = Array.isArray(product.skus) ? product.skus.slice() : [];
        const si = skus.findIndex((s) => String(s.key) === String(key));
        if (si < 0) {
            return;
        }
        skus[si] = Object.assign({}, skus[si], patch || {});
        const selected = skus.filter((s) => s.selected).map((s) => Number(s.newYuan)).filter((n) => Number.isFinite(n) && n > 0);
        const range = selected.length
            ? {
                change_price_min: Math.min.apply(null, selected).toFixed(2),
                change_price_max: Math.max.apply(null, selected).toFixed(2),
            }
            : { change_price_min: "", change_price_max: "" };
        state.sku_price_products.splice(
            idx,
            1,
            Object.assign({}, product, { skus }, range),
        );
    },




    //设置搬家状态
    setBanJiaStatus(state, value) {
        state.banJiaStatus = value;
        IDB.table("productState").put({ id: 1, ...state });
    },
    //设置商机状态（统一为数字，避免字符串 "5" 导致 includes([4,5,6,0]) 为 false、一键提报 v-loading 永远不关）
    setShangJiState(state, value) {
        const n = Number(value);
        state.shangjistate = value != null && value !== "" && Number.isFinite(n) ? n : value;
    },
    //商机日志列表
    setShangJiLog(state, logs) {
        state.shangjilog = logs;
    },
    //新增商机日志（克隆+统一 product_id 字段，新数组引用以便 Vue2 / 表格稳定刷新）
    addShangJiLog(state, log) {
        if (log == null || typeof log !== "object") {
            state.shangjilog = [...state.shangjilog, { msg: String(log), status: 0, product_id: "--", name: "", shop_name: "" }];
            return;
        }
        const row = { ...log };
        const pid = row.product_id ?? row.productId ?? row.id;
        const hasPid = pid !== undefined && pid !== null && String(pid).trim() !== "";
        row.product_id = hasPid ? String(pid) : "--";
        const title = row.product_title ?? row.productTitle ?? row.title;
        row.product_title = title != null && String(title).trim() !== "" ? String(title) : "--";
        state.shangjilog = [...state.shangjilog, row];
    },
    addShangJiLogsBatch(state, logs) {
        if (!Array.isArray(logs) || logs.length === 0) {
            return;
        }
        const rows = logs.map((log) => {
            if (log == null || typeof log !== "object") {
                return { msg: String(log), status: 0, product_id: "--", product_title: "--", name: "", shop_name: "" };
            }
            const row = { ...log };
            const pid = row.product_id ?? row.productId ?? row.id;
            const hasPid = pid !== undefined && pid !== null && String(pid).trim() !== "";
            row.product_id = hasPid ? String(pid) : "--";
            const title = row.product_title ?? row.productTitle ?? row.title;
            row.product_title = title != null && String(title).trim() !== "" ? String(title) : "--";
            return row;
        });
        state.shangjilog = [...state.shangjilog, ...rows];
    },
    setShangJiCollectState(state, value) {
        const n = Number(value);
        state.shangJiCollectState = value != null && value !== "" && Number.isFinite(n) ? n : value;
    },
    setShangJiCollectLog(state, logs) {
        state.shangJiCollectLog = logs;
    },
    addShangJiCollectLog(state, log) {
        if (log == null || typeof log !== "object") {
            state.shangJiCollectLog = [...state.shangJiCollectLog, { msg: String(log), status: 0, name: "", shop_name: "" }];
            return;
        }
        state.shangJiCollectLog = [...state.shangJiCollectLog, { ...log }];
    },
    //设置商机选中
    setShangJiSelection(state, sproducts) {
        state.shangjiselection = sproducts;
    },
    //新增
    addShangJiSelection(state, sproduct) {
        let find = state.shangjiselection.find(it => it.id == sproduct.id)
        if (!find) {
            state.shangjiselection.push(sproduct);
        }
    },
    //删除
    delShangJiSelection(state, sproduct) {
        const index = state.shangjiselection.findIndex(obj => obj.id === sproduct.id);
        if (index !== -1) {
            state.shangjiselection.splice(index, 1);
        }
    },
    //设置自家商品选中
    setShangJiSelectionOnSale(state, sproducts) {
        state.shangjiselectiononsale = sproducts;
    },
    //新增自家商品选中
    addShangJiSelectionOnSale(state, sproduct) {
        let find = state.shangjiselectiononsale.find(it => it.product_id == sproduct.product_id)
        if (!find) {
            state.shangjiselectiononsale.push(sproduct);
        }
    },
    //删除
    delShangJiSelectionOnSale(state, sproduct) {
        const index = state.shangjiselectiononsale.findIndex(obj => obj.product_id === sproduct.product_id);
        if (index !== -1) {
            state.shangjiselectiononsale.splice(index, 1);
        }
    },
    //设置滑块店铺
    setHuaShop(state, shop) {
        let find = state.huaShop.find(it => it.id == shop.id);
        if (!find) {
            state.huaShop.push(shop);
        }
    },
    //删除指定滑块店铺
    delHuaShop(state, shop) {
        state.huaShop = state.huaShop.filter(it => it.id != shop.id);
    },
    //设置商机筛选条件
    setShangJiForm(state, form) {
        state.shangjiForm = Object.assign(state.shangjiForm, form);
    },
    //设置商机列表
    setShangJiProduct(state, sproducts) {
        state.shangjiaproduct = sproducts;
    },
    //设置商机自家商品列表
    setShangJiOnSaleProduct(state, sproducts) {
        state.shangjionsaleproducts = sproducts;
    },
    //添加拼多多商品
    addPddProduct(state, product) {
        if (product?.id > 0) {
            const targetProductIndex = state.pddProducts.findIndex(p => p.id == product.id);
            if (targetProductIndex > -1) {
                state.pddProducts[targetProductIndex] = Object.assign(state.pddProducts[targetProductIndex], product)
            } else {
                state.pddProducts.push(product)
            }
        }
    },
    //更新状态值
    updateState(state, value) {
        //0或者4都是表示执行完了
        state.copyConfig.STATE = value;
    },
    //更新上架商品信息
    updatePublishProduct(state, product) {
        // 更新商品状态信息（如果有）
        if (product?.id > 0) {
            const index = state.product.findIndex(p => p.id == product.id);
            if (index == -1) return;

            const targetProduct = state.product[index];

            const { shopid, status, msg, shop_name, product_id } = product;
            const newStatus = { status, msg, shopid, shop_name, product_id };

            const oldList = targetProduct.statusList || [];
            const statusIndex = oldList.findIndex(s => s.shopid == shopid);

            let newStatusList = [];

            // 更新商品信息
            if (statusIndex > -1) {
                // 更新已有项
                newStatusList = [
                    ...oldList.slice(0, statusIndex),
                    { ...oldList[statusIndex], ...newStatus },
                    ...oldList.slice(statusIndex + 1)
                ];
            } else {
                // 添加新项
                newStatusList = [...oldList, newStatus];
            }
            // 👇 Vue.set 替换整个 product（确保虚拟滚动器能检测到变化）
            Vue.set(state.product, index, {
                ...targetProduct,
                statusList: newStatusList,
            });
        }
    },
    //更新状态值
    wangUpdateState(state, value) {
        state.readConfig.STATE = value;
    },
    getCopyProductIdsV2(state, value) {
        state.copyProductIds.splice(0, value)
    },
    //更新状态值
    pddUpdateState(state, value) {
        state.readConfig.PDDSTATE = value;
    },
    //更新统计信息
    updateCount(state, input) {
        // 更新统计信息
        const { successCount, failCount, allCount } = input;
        state.copyConfig.SUCCESS_ACOUNT = successCount;
        state.copyConfig.FAIL_ACOUNT = failCount;
        state.copyConfig.TOTAL = allCount;
        state.copyConfig.AWAIT_ACOUNT = allCount - successCount - failCount;
    },
    updateWangCount(state, input) {
        // 更新统计信息
        const { successCount, failCount, allCount, product } = input;

        state.readConfig.SUCCESS_ACOUNT = successCount;
        state.readConfig.FAIL_ACOUNT = failCount;
        state.readConfig.TOTAL = allCount;
        state.readConfig.AWAIT_ACOUNT = allCount - successCount - failCount;

        // 更新商品状态信息（如果有）
        if (product?.id > 0) {
            const targetProductIndex = state.product.findIndex(p => p.id == product.id);
            if (targetProductIndex > -1) {
                state.product[targetProductIndex] = { ...state.product[targetProductIndex], ...product }
            } else {
                state.product.push(product)
            }
        }
    },
    jumpproduct(state, input) {
        // 更新统计信息
        const { successCount, failCount, allCount, product } = input;

        state.readConfig.SUCCESS_ACOUNT = successCount;
        state.readConfig.FAIL_ACOUNT = failCount;
        state.readConfig.TOTAL = allCount;
        state.readConfig.AWAIT_ACOUNT = allCount - successCount - failCount;

        // 更新商品状态信息（如果有）
        if (isJumpProductRecordable(product)) {
            state.jumpProduct.push(product)
        }
    },
    updateReadPddProduct(state, product) {
        // 更新商品状态信息（如果有）
        // console.log("==============state.product", state.product)
        if (!isJumpProductRecordable(product)) {
            return;
        }
        if (product.status == 2) {
            const keyItem = product.itemId != null && String(product.itemId).trim() !== "" ? product.itemId : null;
            const keyId = keyItem == null && product.id != null && String(product.id).trim() !== "" ? product.id : null;
            const matchKey = (it) => {
                if (keyItem != null && it.itemId == keyItem) return true;
                if (keyItem != null && String(it.itemId) === String(keyItem)) return true;
                if (keyId != null && it.id == keyId) return true;
                if (keyId != null && String(it.id) === String(keyId)) return true;
                return false;
            };
            const idx = state.jumpProduct.findIndex(matchKey);
            if (idx > -1) {
                state.jumpProduct.splice(idx, 1, { ...state.jumpProduct[idx], ...product });
            } else {
                state.jumpProduct.push(product);
            }
        } else if (product.status == 1) {
            let findIndex = state.product.findIndex((it) => it.itemId == product.itemId)
            if (findIndex > -1) {
                // 重新读取时合并更新（含 change_price 等），避免列表售价残留旧值
                state.product.splice(findIndex, 1, { ...state.product[findIndex], ...product });
            } else {
                state.product.push(product)
            }

        }
    },
    //更新拼多多统计信息
    updateReadPddTongJi(state, input) {
        const { successCount, failCount, allCount } = input;
        state.readConfig.SUCCESS_ACOUNT = successCount;
        state.readConfig.FAIL_ACOUNT = failCount;
        state.readConfig.TOTAL = allCount;
        state.readConfig.AWAIT_ACOUNT = allCount - successCount - failCount;
    },
    //上架日志---字符串文本
    writeCopyLog(state, msg) {
        state.copyLog.push(msg);
    },

    // 修改输入的值，确保刷新页面不会不见
    SET_COPYLINK_VALUE(state, value) {
        state.copyLinkValue = value;
    },
    RESET_PDD_PRODUCT_DATA(state) {
        state.pddProducts = [];
        state.pddFilterId = [];
        state.pddImportPath = "";
    },
    RESET_PRODUCT_DATA(state) {
        state.copyConfig = getBaseConfig('cache/publish.json');
        state.readConfig = getBaseConfig();
        state.editIndex = -1;
        state.imageUploadLockDepth = 0;
        state.cacheDetail = null;
        state.product = [];
        state.jumpProduct = [];
        state.copyLog = [];

        state.readLinkUrls = [];
        state.copyProductIds = [];
        state.copyProductIdsIsFinish = false;
    },
    ////0.未处理 1.准备保存 2，保存成功 3.保存失败
    UPDATE_PRODUCT_SAVE_STATUS_BY_ID(state, { id, value, msg }) {
        let findIndex = state.product.findIndex(item => item.id == id);
        if (findIndex > -1) {
            console.log("@@@@@@@@@@@@@@@设置保存结果",value,id)
            state.product[findIndex].save_status = value;
            if (value === 1 || value === 2) {
                state.product[findIndex].save_err = "";
            } else if (value === 3) {
                state.product[findIndex].save_err = msg || "保存失败";
            }
        }
    },
    UPDATE_PRODUCT_BY_ID(state, { id, result }) {
        let findIndex = state.product.findIndex(item => item.id == id);
        if (findIndex > -1) {
            state.product[findIndex].title = result.title;
            state.product[findIndex].classify_str = result.classify_str;
            state.product[findIndex].update_time = Date.now(); // 更新编辑时间

            if (result.change_attribute_json) {
                state.product[findIndex].change_attribute_json = result.change_attribute_json;
            }
            if (result.cid) {
                state.product[findIndex].cid = result.cid;
            }
        }
    },
    UPDATE_PRODUCT_PRICE_RANGE(state, { id, change_price_min, change_price_max }) {
        let findIndex = state.product.findIndex(item => item.id == id);
        if (findIndex > -1) {
            if (change_price_min != null) {
                state.product[findIndex].change_price_min = change_price_min;
            }
            if (change_price_max != null) {
                state.product[findIndex].change_price_max = change_price_max;
            }
        }
    },
    UPDATE_PRODUCT_LOCK_STATUS_BY_IDS(state, { ids, is_lock_source_json_data }) {
        for (let i = 0; i < ids.length; i++) {
            const findIndex = state.product.findIndex(item => item.id == ids[i]);
            if (findIndex > -1) {
                state.product[findIndex].is_lock_source_json_data = is_lock_source_json_data;
            }
        }
    },
    removePddProduct(state, index) {
        let pro = state.pddProducts[index];

        if (pro.id) {
            SaveProductQueue.add(pro, 'delete'); // 添加到删除队列
        }

        state.pddProducts.splice(index, 1);
    },
    // 删除单条记录
    REMOVE_PRODUCT(state, { index, item }) {
        let nindex = state.product.findIndex(p => p.id == item.id);
        if (nindex > -1) {
            let pro = state.product[nindex];
            if (pro.id) {
                SaveProductQueue.add(pro, 'delete'); // 添加到删除队列
            }

            state.product.splice(nindex, 1);
        }


        // 如果删除的是当前编辑的商品，就清除当前编辑的商品
        if (index == state.editIndex) {
            state.editIndex = -1;
            state.cacheDetail = null
        } else if (index > -1 && index < state.editIndex) {
            // 删除的是当前编辑商品前面的商品，编辑下标前移一位保持对齐
            state.editIndex = state.editIndex - 1;
        }
    },
    // 修改商品类目
    UPDATE_PRODUCT_CATE(state, { index, data, data_format, cid, change_attribute_json }) {
        if (index > -1 && state.product[index]?.classify_str) {
            // 修改分类
            state.product[index].classify_str = data_format.c_path.join(">");
            if (cid) {
                state.product[index].cid = cid;
            }
            if (change_attribute_json) {
                state.product[index].change_attribute_json = change_attribute_json;
            }
            // console.log("修改后的产品信息：", state.product[index]);
        }
    },
    // 批量应用到分类底下的所有商品
    UPDATE_PRODUCT_CID(state, { cid, itemid, value }) {
        for (let i = 0; i < state.product.length; i++) {
            let item = state.product[i];
            if (item.cid == cid) {
                const change_attribute_json = { ...item.change_attribute_json }
                change_attribute_json[itemid] = value;
                state.product[i].change_attribute_json = { ...change_attribute_json }
            }
        }
    },
    // 批量应用到未匹配的商品类目
    UPDATE_PRODUCT_UNSETCATE(state, { data, data_format }) {
        // 过滤出所有未匹配的商品类目，然后循环修改设置类目

    },
    // 设置编辑序列
    SET_EDIT_INDEX(state, index) {
        // 判断上一次编辑的id是否存在
        if (state.editIndex) {
            state.lastEditIndex = state.editIndex;
        }
        state.editIndex = index;
    },
    UPDATE_LOADING(state, value) {
        state.loading = value
    },
    SET_CACHE_DETAIL(state, data) {
        const cloned = JSON.parse(JSON.stringify(data)); //对数据进行拷贝
        // 从 source_json_data 旁路水合多店鉴图 overlays
        if (
            (!cloned.ai_polish_overlays || typeof cloned.ai_polish_overlays !== "object") &&
            cloned.source_json_data?.__ai_polish_overlays
        ) {
            cloned.ai_polish_overlays = cloned.source_json_data.__ai_polish_overlays;
        }
        state.cacheDetail = cloned;
    },
    // 显示图片选择器 ，并且记录当前选择的字段值,以及操作（owner 区分宿主页面，避免多实例同时弹出）
    SHOW_IMAGE_SELECT_AND_SET_FILED(state, { filed, type, owner }) {
        state.imgSelect = {
            show: true,
            filed,
            type,
            owner: owner || ""
        }
    },
    // 统一修改字段值， 格式 path = 'product.0.images' value = any
    UPDATE_FILED_VALUE(state, { path, value, type = 'reset' }) {
        // console.log("UPDATE_FILED_VALUE", path, value, type);
        const keys = path.split('.');

        let current = state;

        for (let i = 0; i < keys.length - 1; i++) {
            const key = keys[i];
            if (current?.[key]) {
                current = current[key];
            }
        }

        if (type == "reset") {
            current[keys[keys.length - 1]] = value;
        } else if (type == "add") {
            current[keys[keys.length - 1]].push(value);
        }
    },
    SET_COPY_TIME(state, value) {
        state.copyTime = value;
    },
    SET_COPY_START_TIMESTAMP(state, ts) {
        state.startTimestamp = ts;
    },
    SET_SHOP_LIST(state, data) {
        // 如果数据不是数组，就转化为数组
        state.shopList = data || [];
        if (data?.length == 0) {
            state.selectShop = ""; // 清空选择的店铺
        }
    },
    SET_SELECT_SHOP(state, id) {
        state.selectShop = id;
    },
    SET_COPY_SHOP_IDS(state, ids) {
        state.copyShopIds = ids;
    },
    // 移除第一个
    REOMVE_FIRST_ITEM(state, field) {
        state[field]?.shift();
    },
    RESET_PRODUCT_STATUS(state) {
        for (let i = 0; i < state.product.length; i++) {
            state.product[i].statusList = []
        }
    },
    //剔除掉那些失败的
    RESET_PRODUCT_STATUS_BY_NEWDATA(state) {
        //剔除掉失败的,成功的保留
        for (let i = 0; i < state.product?.length; i++) {
            if (state.product[i].statusList && state.product[i].statusList.length > 0) {
                let successArray = [];
                for (let j = 0; j < state.product[i].statusList.length; j++) {
                    if (state.product[i].statusList[j]?.status == 1) {
                        //成功
                        successArray.push(state.product[i].statusList[j]);
                    }
                }
                if (successArray.length > 0) {
                    state.product[i].statusList = successArray;
                } else {
                    state.product[i].statusList = [];
                }
            }
        }
    },
    // 恢复state
    RECOVER_STATE(state, { data, field }) {
        console.log('==============', data)
        const keys = Object.keys(data);
        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            // 如果在上架中中断了，就暂停，手动点击恢复
            if (field && !field.includes(key)) {
                continue;
            }
            if (key == "loading") {
                state[key] = false;
            } else if (['readConfig', 'copyConfig'].includes(key)) {
                let s = data[key]?.STATE == 2 ? 7 : 0
                // state[key] = { ...data[key], STATE: s };
            } else if (['shangjistate', 'shangJiCollectState', 'titlestate', 'attrstate', 'flashsalestate', 'offlineDeleteState', 'draftsWebReleaseState', 'draftsSyncState', 'violationBatchSyncState', 'deadStockAnalyzeState', 'deadStockBatchState', 'lowQualityFetchState', 'lowQualityBatchState', 'qualityDiagnoseFetchState', 'qualityDiagnoseBatchState', 'titleLoadState', 'shortTitleLoadState', 'brandLoadState', 'aftersaleLoadState', 'skuPricestate', 'skuPriceLoadState', 'skuPricePreviewState'].includes(key)) {
                data[key] = (data[key] == 2 ? 4 : 0)
            } else if (['huaShop', 'shangjiselection', 'shangjilog', 'shangJiCollectLog', 'shangjiaproduct', 'shangjionsaleproducts', 'shangjiselectiononsale', 'title_products', 'title_product_selects', 'attr_products', 'attr_product_selects', 'flashsaleCreateResults', 'flashsaleCreateFailReasons', 'sku_price_products', 'sku_price_product_selects'].includes(key)) {
                data[key] = []
            } else {
                state[key] = data[key];
            }
        }
        console.log("@@@@@@@@@@@@@@load", state, field)
    },
    // 开始备份
    START_BACKUP(state, time) {
        if (timers) clearInterval(timers);

        timers = setInterval(() => {
            console.time("put");
            IDB.table("productState").put({ id: 1, ...state });
            console.timeEnd("put"); // 看 IndexedDB 写入耗时
            // console.log(rs);
        }, time * 1000);
    },
    // 停止备份
    STOP_BACKUP(state) {
        clearInterval(timers);
    },
};

function draftsParseIdNameCodeList(raw) {
    if (!raw) return [];
    return String(raw)
        .split(/[\n,，]+/)
        .map((s) => s.trim())
        .filter(Boolean);
}

function draftsNormalizeIdNameCode(raw) {
    return draftsParseIdNameCodeList(raw).join(",");
}

function draftsBuildWhere(snapshot) {
    const { tab, where = {}, tabWhere = {}, dateRange } = snapshot || {};
    const merged = { ...where, ...(tabWhere[tab] || {}) };
    if (tab) {
        merged.tab = tab;
    }
    if (merged.id_name_code) {
        merged.id_name_code = draftsNormalizeIdNameCode(merged.id_name_code);
    }
    if (dateRange?.length) {
        if (tab === "draft") {
            merged.draft_start_time = dateRange[0];
            merged.draft_end_time = dateRange[1];
        } else {
            merged.start_time = dateRange[0];
            merged.end_time = dateRange[1];
        }
    }
    return merged;
}

function draftsIsSyncStopped(state) {
    return state.draftsSyncState === 3 || state.draftsSyncState === 4;
}

function violationBatchIsSyncStopped(state) {
    return state.violationBatchSyncState === 3 || state.violationBatchSyncState === 4;
}

async function draftsFetchPage(shop, where, page, commit, getState) {
    let retryCount = 0;
    while (true) {
        if (draftsIsSyncStopped(getState())) {
            return null;
        }
        const rs = await Call.invoke(
            "douDianBatchOperationProduct.searchDraftsProduct",
            shop,
            { ...where, page },
        );
        if (rs.code == 1) {
            if (!rs.pageCount) {
                rs.pageCount = 0;
            }
            return rs;
        }
        if (rs.msg.includes("请求接口失败")) {
            if (rs.msg.includes("登录信息已失效")) {
                return rs;
            }
            if (retryCount < 3) {
                commit(
                    "appendDraftsSyncLog",
                    `店铺：${shop.shop_name}第${page + 1}页请求失败，重试中...`,
                );
                await new Promise((r) =>
                    setTimeout(r, Math.floor(Math.random() * 2001 + 13000)),
                );
                retryCount++;
                continue;
            }
        }
        return rs;
    }
}

function draftsLogPageResult(commit, shop, page, rs, pageCount) {
    if (rs.switchedToListV2) {
        commit(
            "appendDraftsSyncLog",
            `店铺：${shop.shop_name} 网页访问频繁，已自动切换官方listV2继续同步`,
        );
    }
    if (rs.code == 1) {
        const via = rs.fromListV2 ? "（官方listV2）" : "";
        commit(
            "appendDraftsSyncLog",
            `店铺：${shop.shop_name}，已经获取到第${page + 1}页的${rs.dataLength}条商品，共${pageCount}页数据${via}`,
        );
    } else if ((rs.msg || "").includes("登录信息已失效")) {
        commit("appendDraftsSyncLog", `${rs.msg}`);
    } else {
        commit(
            "appendDraftsSyncLog",
            `店铺：${shop.shop_name}第${page + 1}页查询失败：${rs.msg}`,
        );
    }
}

async function draftsQueryShop({ commit, state }, shop, snapshot) {
    const where = draftsBuildWhere(snapshot);
    const concurrency = Math.max(1, parseInt(snapshot.pageConcurrency, 10) || 4);
    commit("appendDraftsSyncLog", `开始同步店铺：${shop.shop_name}`);
    try {
        const firstRs = await draftsFetchPage(shop, where, 0, commit, () => state);
        if (!firstRs || draftsIsSyncStopped(state)) {
            return;
        }
        const pageCount = firstRs.pageCount || 0;
        draftsLogPageResult(commit, shop, 0, firstRs, pageCount);
        if (firstRs.code != 1 || pageCount <= 1) {
            return;
        }
        for (let start = 1; start < pageCount; start += concurrency) {
            if (draftsIsSyncStopped(state)) {
                break;
            }
            const pages = [];
            for (
                let page = start;
                page < Math.min(start + concurrency, pageCount);
                page++
            ) {
                pages.push(page);
            }
            const results = await Promise.all(
                pages.map((page) =>
                    draftsFetchPage(shop, where, page, commit, () => state),
                ),
            );
            for (let i = 0; i < results.length; i++) {
                const rs = results[i];
                if (!rs) {
                    continue;
                }
                draftsLogPageResult(commit, shop, pages[i], rs, pageCount);
                if (rs.msg && rs.msg.includes("登录信息已失效")) {
                    return;
                }
            }
            if (start + concurrency < pageCount && !draftsIsSyncStopped(state)) {
                const time = snapshot.intervalTime || 1;
                await new Promise((r) => setTimeout(r, time));
            }
        }
    } catch (e) {
        console.log("draftsQueryShop error:", e.message);
    }
}

async function violationBatchFetchPage(shop, where, page, commit, getState) {
    let retryCount = 0;
    while (true) {
        if (violationBatchIsSyncStopped(getState())) {
            return null;
        }
        const rs = await Call.invoke(
            "douDianBatchOperationProduct.searchViolationBatchProduct",
            shop,
            { ...where, page },
        );
        if (rs.code == 1) {
            if (!rs.pageCount) {
                rs.pageCount = 0;
            }
            return rs;
        }
        if (rs.msg.includes("请求接口失败")) {
            if (rs.msg.includes("登录信息已失效")) {
                return rs;
            }
            if (retryCount < 3) {
                commit(
                    "appendViolationBatchSyncLog",
                    `店铺：${shop.shop_name}第${page + 1}页请求失败，重试中...`,
                );
                await new Promise((r) =>
                    setTimeout(r, Math.floor(Math.random() * 2001 + 13000)),
                );
                retryCount++;
                continue;
            }
        }
        return rs;
    }
}

function violationBatchLogPageResult(commit, shop, page, rs, pageCount) {
    if (rs.switchedToListV2) {
        commit(
            "appendViolationBatchSyncLog",
            `店铺：${shop.shop_name} 网页访问频繁，已自动切换官方listV2继续同步`,
        );
    }
    if (rs.code == 1) {
        const saved = rs.savedCount != null ? rs.savedCount : 0;
        const violation = rs.violationCount != null ? rs.violationCount : 0;
        const via = rs.fromListV2 ? "（官方listV2）" : "";
        commit(
            "appendViolationBatchSyncLog",
            `店铺：${shop.shop_name}，第${page + 1}页扫描${rs.dataLength || 0}条，入库${saved}条（违规${violation}条），共${pageCount}页${via}`,
        );
    } else if ((rs.msg || "").includes("登录信息已失效")) {
        commit("appendViolationBatchSyncLog", `${rs.msg}`);
    } else {
        commit(
            "appendViolationBatchSyncLog",
            `店铺：${shop.shop_name}第${page + 1}页查询失败：${rs.msg}`,
        );
    }
}

async function violationBatchQueryShop({ commit, state }, shop, snapshot) {
    const where = draftsBuildWhere(snapshot);
    const concurrency = Math.max(1, parseInt(snapshot.pageConcurrency, 10) || 4);
    commit("appendViolationBatchSyncLog", `开始同步店铺：${shop.shop_name}`);
    try {
        const firstRs = await violationBatchFetchPage(shop, where, 0, commit, () => state);
        if (!firstRs || violationBatchIsSyncStopped(state)) {
            return;
        }
        const pageCount = firstRs.pageCount || 0;
        violationBatchLogPageResult(commit, shop, 0, firstRs, pageCount);
        if (firstRs.code != 1 || pageCount <= 1) {
            return;
        }
        for (let start = 1; start < pageCount; start += concurrency) {
            if (violationBatchIsSyncStopped(state)) {
                break;
            }
            const pages = [];
            for (
                let page = start;
                page < Math.min(start + concurrency, pageCount);
                page++
            ) {
                pages.push(page);
            }
            const results = await Promise.all(
                pages.map((page) =>
                    violationBatchFetchPage(shop, where, page, commit, () => state),
                ),
            );
            for (let i = 0; i < results.length; i++) {
                const rs = results[i];
                if (!rs) {
                    continue;
                }
                violationBatchLogPageResult(commit, shop, pages[i], rs, pageCount);
                if (rs.msg && rs.msg.includes("登录信息已失效")) {
                    return;
                }
            }
            if (start + concurrency < pageCount && !violationBatchIsSyncStopped(state)) {
                const time = snapshot.intervalTime || 1;
                await new Promise((r) => setTimeout(r, time));
            }
        }
    } catch (e) {
        console.log("violationBatchQueryShop error:", e.message);
    }
}

function titleLoadIsStopped(state) {
    return state.titleLoadState === 3 || state.titleLoadState === 4;
}

/** 短标题/品牌/三包：与标题相同的范围加载配置 */
const BATCH_SCOPE_LOAD_CFG = {
    shortTitle: {
        stateKey: "shortTitleLoadState",
        setState: "setShortTitleLoadState",
        setSnapshot: "setShortTitleLoadSnapshot",
        setProgress: "setShortTitleLoadProgress",
        resetProgress: "resetShortTitleLoadProgress",
        setProducts: "setShortTitleProducts",
        setSelects: "setShortTitleProductSelects",
    },
    brand: {
        stateKey: "brandLoadState",
        setState: "setBrandLoadState",
        setSnapshot: "setBrandLoadSnapshot",
        setProgress: "setBrandLoadProgress",
        resetProgress: "resetBrandLoadProgress",
        setProducts: "setBrandProducts",
        setSelects: "setBrandProductSelects",
    },
    aftersale: {
        stateKey: "aftersaleLoadState",
        setState: "setAftersaleLoadState",
        setSnapshot: "setAftersaleLoadSnapshot",
        setProgress: "setAftersaleLoadProgress",
        resetProgress: "resetAftersaleLoadProgress",
        setProducts: "setAftersaleProducts",
        setSelects: "setAftersaleProductSelects",
    },
    skuPrice: {
        stateKey: "skuPriceLoadState",
        setState: "setSkuPriceLoadState",
        setSnapshot: "setSkuPriceLoadSnapshot",
        setProgress: "setSkuPriceLoadProgress",
        resetProgress: "resetSkuPriceLoadProgress",
        setProducts: "setSkuPriceProducts",
        setSelects: "setSkuPriceProductSelects",
    },
};

function batchScopeLoadIsStopped(state, cfg) {
    const v = state[cfg.stateKey];
    return v === 3 || v === 4;
}

async function batchScopeQueryShop({ commit, state }, shop, snapshot, rlist, cfg) {
    const where = titleBuildWhere(shop, snapshot);
    const concurrency = Math.max(1, parseInt(snapshot.pageConcurrency, 10) || 4);
    const filters = snapshot.filters || {};
    const firstRs = await titleFetchPage(shop, where, 0);
    if (batchScopeLoadIsStopped(state, cfg)) {
        return;
    }
    if (!firstRs || firstRs.code != 1) {
        return;
    }
    if (firstRs.total == 0 || !firstRs.data || firstRs.data.length == 0) {
        return;
    }
    const pageCount = Math.max(
        1,
        Math.ceil(firstRs.total / (where.pageSize || 100)),
    );
    commit(cfg.setProgress, { page: 1, pageCount });
    titleAppendFiltered(rlist, firstRs.data, filters);
    commit(cfg.setProducts, rlist.slice());
    if (pageCount <= 1) {
        return;
    }
    for (let start = 1; start < pageCount; start += concurrency) {
        if (batchScopeLoadIsStopped(state, cfg)) {
            break;
        }
        const pages = [];
        for (
            let page = start;
            page < Math.min(start + concurrency, pageCount);
            page++
        ) {
            pages.push(page);
        }
        const results = await Promise.all(
            pages.map((page) => titleFetchPage(shop, where, page)),
        );
        if (batchScopeLoadIsStopped(state, cfg)) {
            break;
        }
        let shouldStopShop = false;
        for (let i = 0; i < results.length; i++) {
            const rs = results[i];
            if (!rs || rs.code != 1) {
                shouldStopShop = true;
                break;
            }
            if (!rs.data || rs.data.length == 0) {
                shouldStopShop = true;
                break;
            }
            titleAppendFiltered(rlist, rs.data, filters);
        }
        commit(cfg.setProgress, {
            page: Math.min(start + pages.length, pageCount),
            pageCount,
        });
        commit(cfg.setProducts, rlist.slice());
        if (shouldStopShop) {
            break;
        }
    }
}

function titleFilterProduct(data, filters) {
    if (!filters) {
        return true;
    }
    if (
        filters.stockMax > 0 &&
        filters.stockMin <= filters.stockMax
    ) {
        if (
            !(
                data.stock_num <= filters.stockMax &&
                data.stock_num >= filters.stockMin
            )
        ) {
            return false;
        }
    }
    if (filters.brand && data.brand) {
        const brandArray = [];
        if (data?.brand?.name_en) {
            brandArray.push(data.brand.name_en.toLowerCase());
        }
        if (data?.brand?.name_cn) {
            brandArray.push(data.brand.name_cn.toLowerCase());
        }
        if (brandArray.length > 0) {
            const brandName = brandArray.join("/");
            if (!brandName.includes(String(filters.brand).toLowerCase())) {
                return false;
            }
        }
    }
    if (
        filters.qualityMax > 0 &&
        filters.qualityMin <= filters.qualityMax
    ) {
        if (data.quality_score == null) {
            return false;
        }
        if (
            !(
                data.quality_score <= filters.qualityMax &&
                data.quality_score >= filters.qualityMin
            )
        ) {
            return false;
        }
    }
    if (filters.keyword && !titleMatchKeywordProduct(data, filters)) {
        return false;
    }
    return true;
}

function titleIsProductIdToken(token) {
    return /^\d{10,}$/.test(String(token || "").trim());
}

function titleCharsInOrder(haystack, needle) {
    const h = String(haystack || "");
    const n = String(needle || "");
    if (!n) {
        return true;
    }
    let i = 0;
    for (let k = 0; k < h.length && i < n.length; k++) {
        if (h[k] === n[i]) {
            i++;
        }
    }
    return i >= n.length;
}

function titleCollectMatchTexts(data) {
    const texts = [];
    const push = (v) => {
        const s = v != null ? String(v).trim() : "";
        if (s) {
            texts.push(s);
        }
    };
    push(data?.name);
    push(data?.title);
    push(data?.product_id);
    push(data?.product_id_str);
    push(data?.sku_code);
    push(data?.code);
    push(data?.outer_id);
    push(data?.item_num);
    push(data?.product_code);
    push(data?.out_product_id);
    return texts;
}

function titleMatchKeywordProduct(data, filters) {
    const raw = String(filters.keyword || "").trim();
    if (!raw) {
        return true;
    }
    const tokens = raw.split(/[,，\n]+/).map((s) => s.trim()).filter(Boolean);
    if (!tokens.length) {
        return true;
    }
    const mode = filters.titleMatchMode || "phrase";
    const texts = titleCollectMatchTexts(data);
    const title = String(data?.name || data?.title || "");
    const pid = String(data?.product_id || data?.product_id_str || "");
    return tokens.some((token) => {
        if (titleIsProductIdToken(token)) {
            return pid === token || texts.some((t) => t === token);
        }
        if (mode === "exact") {
            return title === token;
        }
        if (mode === "keyword") {
            return texts.some((t) => titleCharsInOrder(t, token));
        }
        return texts.some((t) => t.includes(token));
    });
}

function titleBuildWhere(shop, snapshot) {
    const filters = snapshot.filters || {};
    if (snapshot.activeTab === "productId") {
        const where = {
            needBrand: snapshot.kind !== "skuPrice",
            shop_name: shop.shop_name,
            pageSize: 100,
            id_name_code: "",
            group_id: "",
            sku_type: "",
            tab: "all",
            business_type: 4,
            is_online: 1,
            not_for_sale_search_type: 1,
            from_mng: 1,
        };
        if (snapshot.ids) {
            const aids = String(snapshot.ids)
                .split("\n")
                .map((s) => (s || "").trim())
                .filter(Boolean);
            if (aids.length > 0) {
                where.id_name_code = aids.join(",");
            }
        }
        return where;
    }
    const where = {
        needBrand: snapshot.kind !== "skuPrice",
        shop_name: shop.shop_name,
        pageSize: 100,
        id_name_code: "",
        group_id: "",
        sku_type: "",
        tab: filters.status,
        business_type: 4,
        not_for_sale_search_type: 1,
        from_mng: 1,
    };
    if (filters.status === "onSale" || filters.status === "sellOut") {
        where.check_status = 3;
        where.is_online = 1;
    } else if (filters.status === "offline") {
        // 已下架：必须 is_offline=1，不能带 is_online=1，否则会混入售卖中
        where.is_online = "";
        where.is_offline = 1;
        where.order_field = "offline_time";
        where.sort = "desc";
    } else if (filters.status === "unpass") {
        // 审核不通过：worker 内改走 publishList?publish_status=2（勿用 tproduct/list tab=unpass）
        where.is_online = "";
    } else if (filters.status === "draft") {
        where.is_drafting = 1;
        where.draft_time_sort = "desc";
        where.order_field = "draft_time";
    } else {
        // all 等：不含草稿，按在线商品池查
        where.is_online = 1;
    }
    if (filters.createdAt && filters.createdAt.length > 0) {
        where.start_time = filters.createdAt[0];
        where.end_time = filters.createdAt[1];
    }
    let priceMin = Number(filters.priceMin) || 0;
    let priceMax = Number(filters.priceMax) || 0;
    if (priceMin > 0 && priceMax === 0) {
        priceMax = priceMin;
    }
    if (priceMin > priceMax) {
        const tmp = priceMin;
        priceMin = priceMax;
        priceMax = tmp;
    }
    if (priceMin > 0) {
        where.sku_price_min = priceMin * 100;
    }
    if (priceMax > 0) {
        where.sku_price_max = priceMax * 100;
    }
    let saleMin = Number(filters.saleMin) || 0;
    let saleMax = Number(filters.saleMax) || 0;
    if (saleMin > 0 && saleMax === 0) {
        saleMax = saleMin;
    }
    if (saleMin > saleMax) {
        const tmp = saleMin;
        saleMin = saleMax;
        saleMax = tmp;
    }
    if (saleMin > 0) {
        where.sell_num_min = saleMin;
    }
    if (saleMax > 0) {
        where.sell_num_max = saleMax;
    }
    if (filters.category?.length > 0) {
        where["category[]"] = filters.category[filters.category.length - 1];
        where.category_leaf_id = filters.category[filters.category.length - 1];
    }
    const id_name_code = [];
    if (filters.tags) {
        id_name_code.push(...String(filters.tags).split(","));
    }
    if (filters.sku) {
        id_name_code.push(...String(filters.sku).split(","));
    }
    if (filters.productIds) {
        id_name_code.push(...String(filters.productIds).split(","));
    }
    if (filters.keyword) {
        id_name_code.push(
            ...String(filters.keyword)
                .split(/[,，\n]+/)
                .map((s) => s.trim())
                .filter(Boolean),
        );
    }
    if (id_name_code.length > 0) {
        where.id_name_code = id_name_code.join(",");
    }
    if (filters.auditAt && filters.auditAt.length === 2) {
        where.audit_start_time = filters.auditAt[0];
        where.audit_end_time = filters.auditAt[1];
    }
    if (filters.shipMode && filters.shipMode !== "all") {
        const ar = String(filters.shipMode).split("@");
        if (ar.length === 1) {
            where.delivery_mode = ar[0];
        } else if (ar.length === 2) {
            where.delivery_mode = ar[0];
            where.delivery_delay_day = ar[1];
        }
    }
    return where;
}

function titleAppendFiltered(rlist, data, filters) {
    if (!data || !data.length) {
        return;
    }
    for (let k = 0; k < data.length; k++) {
        if (titleFilterProduct(data[k], filters)) {
            data[k].run_status = 0;
            data[k].run_msg = "";
            if (data[k].shop) {
                if (data[k].shop_id == null) {
                    data[k].shop_id = data[k].shop.id;
                }
                if (!data[k].shop_name) {
                    data[k].shop_name = data[k].shop.shop_name;
                }
            }
            if (!data[k]._rowKey) {
                data[k]._rowKey = skuPriceRowKey(data[k]);
            }
            rlist.push(data[k]);
        }
    }
}

async function titleFetchPage(shop, where, page) {
    return Call.invoke("douDianBatchOperationProduct.tproductList", shop, {
        ...where,
        page,
    });
}

async function titleQueryShop({ commit, state }, shop, snapshot, rlist) {
    const where = titleBuildWhere(shop, snapshot);
    const concurrency = Math.max(1, parseInt(snapshot.pageConcurrency, 10) || 4);
    const filters = snapshot.filters || {};
    const firstRs = await titleFetchPage(shop, where, 0);
    if (titleLoadIsStopped(state)) {
        return;
    }
    if (!firstRs || firstRs.code != 1) {
        return;
    }
    if (firstRs.total == 0 || !firstRs.data || firstRs.data.length == 0) {
        return;
    }
    const pageCount = Math.max(
        1,
        Math.ceil(firstRs.total / (where.pageSize || 100)),
    );
    commit("setTitleLoadProgress", { page: 1, pageCount });
    titleAppendFiltered(rlist, firstRs.data, filters);
    commit("setTitleProducts", rlist.slice());
    if (pageCount <= 1) {
        return;
    }
    for (let start = 1; start < pageCount; start += concurrency) {
        if (titleLoadIsStopped(state)) {
            break;
        }
        const pages = [];
        for (
            let page = start;
            page < Math.min(start + concurrency, pageCount);
            page++
        ) {
            pages.push(page);
        }
        const results = await Promise.all(
            pages.map((page) => titleFetchPage(shop, where, page)),
        );
        if (titleLoadIsStopped(state)) {
            break;
        }
        let shouldStopShop = false;
        for (let i = 0; i < results.length; i++) {
            const rs = results[i];
            if (!rs || rs.code != 1) {
                shouldStopShop = true;
                break;
            }
            if (!rs.data || rs.data.length == 0) {
                shouldStopShop = true;
                break;
            }
            titleAppendFiltered(rlist, rs.data, filters);
        }
        commit("setTitleLoadProgress", {
            page: Math.min(start + pages.length, pageCount),
            pageCount,
        });
        commit("setTitleProducts", rlist.slice());
        if (shouldStopShop) {
            break;
        }
    }
}

const actions = {

    getCopyProductIdsV2({ state, commit, dispatch }, value = 100) {
        let isFinish = false;
        if (lock) {
            return { isFinish: isFinish, data: undefined, msg: "并发锁锁住" };
        }
        lock = true;
        let cpy = state.copyProductIds.slice(0, value)
        console.log("=================getCopyProductIdsV2", cpy)
        commit('getCopyProductIdsV2', value);
        if (state.copyProductIdsIsFinish && state.copyProductIds.length == 0) {
            //队列全部消化光了
            isFinish = true;
        }
        lock = false;
        return { isFinish: isFinish, data: cpy, msg: "获取数组成功" };
    },
    async startTitleProductsLoad({ commit, state }, payload) {
        if ([1, 2, 3].includes(state.titleLoadState)) {
            return { code: -1, msg: "商品加载进行中" };
        }
        const shops = Array.isArray(payload?.shops) ? payload.shops : [];
        if (!shops.length) {
            return { code: -1, msg: "请先选择店铺" };
        }
        commit("setTitleLoadSnapshot", {
            shopids: payload.shopids || shops.map((s) => s.id),
            activeTab: payload.activeTab,
            ids: payload.ids,
            filters: payload.filters ? { ...payload.filters } : {},
            pageConcurrency: payload.pageConcurrency,
        });
        commit("resetTitleLoadProgress");
        commit("setTitleProducts", []);
        commit("setTitleProductSelects", []);
        commit("setTitleLoadState", 1);
        commit("setTitleLoadState", 2);
        const rlist = [];
        try {
            for (let i = 0; i < shops.length; i++) {
                if (titleLoadIsStopped(state)) {
                    break;
                }
                await titleQueryShop({ commit, state }, shops[i], payload, rlist);
            }
            commit("setTitleProducts", rlist.slice());
            if (state.titleLoadState === 3) {
                commit("setTitleLoadState", 4);
            } else if (state.titleLoadState === 2) {
                commit("setTitleLoadState", 5);
            }
            return { code: 1, total: rlist.length };
        } catch (e) {
            commit("setTitleLoadState", 4);
            return { code: -1, msg: e.message || "加载失败" };
        }
    },
    stopTitleProductsLoad({ commit, state }) {
        if ([1, 2].includes(state.titleLoadState)) {
            commit("setTitleLoadState", 3);
        }
    },
    async startBatchScopeProductsLoad({ commit, state }, payload) {
        const kind = payload?.kind;
        const cfg = BATCH_SCOPE_LOAD_CFG[kind];
        if (!cfg) {
            return { code: -1, msg: "未知加载类型" };
        }
        if ([1, 2, 3].includes(state[cfg.stateKey])) {
            return { code: -1, msg: "商品加载进行中" };
        }
        const shops = Array.isArray(payload?.shops) ? payload.shops : [];
        if (!shops.length) {
            return { code: -1, msg: "请先选择店铺" };
        }
        commit(cfg.setSnapshot, {
            kind,
            shopids: payload.shopids || shops.map((s) => s.id),
            activeTab: payload.activeTab,
            ids: payload.ids,
            filters: payload.filters ? { ...payload.filters } : {},
            pageConcurrency: payload.pageConcurrency,
        });
        commit(cfg.resetProgress);
        commit(cfg.setProducts, []);
        commit(cfg.setSelects, []);
        commit(cfg.setState, 1);
        commit(cfg.setState, 2);
        const rlist = [];
        try {
            for (let i = 0; i < shops.length; i++) {
                if (batchScopeLoadIsStopped(state, cfg)) {
                    break;
                }
                commit(cfg.setProgress, {
                    shopIndex: i + 1,
                    shopCount: shops.length,
                    shopName: shops[i].shop_name || "",
                    page: 0,
                    pageCount: 0,
                });
                await batchScopeQueryShop(
                    { commit, state },
                    shops[i],
                    payload,
                    rlist,
                    cfg,
                );
            }
            commit(cfg.setProducts, rlist.slice());
            if (state[cfg.stateKey] === 3) {
                commit(cfg.setState, 4);
            } else if (state[cfg.stateKey] === 2) {
                commit(cfg.setState, 5);
            }
            return { code: 1, total: rlist.length };
        } catch (e) {
            commit(cfg.setState, 4);
            return { code: -1, msg: e.message || "加载失败" };
        }
    },
    stopBatchScopeProductsLoad({ commit, state }, kind) {
        const cfg = BATCH_SCOPE_LOAD_CFG[kind];
        if (!cfg) {
            return;
        }
        if ([1, 2].includes(state[cfg.stateKey])) {
            commit(cfg.setState, 3);
        }
    },
    async startDraftsSync({ commit, state }, payload) {
        if ([1, 2, 3].includes(state.draftsSyncState)) {
            return { code: -1, msg: "同步任务进行中" };
        }
        commit("setDraftsSyncSnapshot", payload);
        commit("resetDraftsSyncLog");
        commit("setDraftsSyncState", 1);
        commit("setDraftsSyncState", 2);
        try {
            const clearRs = await Call.invoke(
                "douDianBatchOperationProduct.clearDraftsProduct",
                payload.nids,
            );
            if (clearRs.code != 1) {
                commit("appendDraftsSyncLog", clearRs.msg || "清理历史数据失败");
                commit("setDraftsSyncState", 4);
                return { code: -1, msg: clearRs.msg || "清理历史数据失败" };
            }
            for (let i = 0; i < payload.nids.length; i++) {
                if (draftsIsSyncStopped(state)) {
                    break;
                }
                await draftsQueryShop({ commit, state }, payload.nids[i], payload);
            }
            if (state.draftsSyncState === 3) {
                commit("setDraftsSyncState", 4);
            } else if (state.draftsSyncState === 2) {
                commit("setDraftsSyncState", 5);
            }
            return { code: 1 };
        } catch (e) {
            commit("appendDraftsSyncLog", "查询失败：" + e.message);
            commit("setDraftsSyncState", 4);
            return { code: -1, msg: e.message };
        }
    },
    stopDraftsSync({ commit, state }) {
        if ([1, 2].includes(state.draftsSyncState)) {
            commit("setDraftsSyncState", 3);
        }
    },
    async startViolationBatchSync({ commit, state }, payload) {
        if ([1, 2, 3].includes(state.violationBatchSyncState)) {
            return { code: -1, msg: "同步任务进行中" };
        }
        commit("setViolationBatchSyncSnapshot", payload);
        commit("resetViolationBatchSyncLog");
        commit("setViolationBatchSyncState", 1);
        commit("setViolationBatchSyncState", 2);
        try {
            const clearRs = await Call.invoke(
                "douDianBatchOperationProduct.clearViolationBatchProduct",
                payload.nids,
            );
            if (clearRs.code != 1) {
                commit("appendViolationBatchSyncLog", clearRs.msg || "清理历史数据失败");
                commit("setViolationBatchSyncState", 4);
                return { code: -1, msg: clearRs.msg || "清理历史数据失败" };
            }
            for (let i = 0; i < payload.nids.length; i++) {
                if (violationBatchIsSyncStopped(state)) {
                    break;
                }
                await violationBatchQueryShop({ commit, state }, payload.nids[i], payload);
            }
            if (state.violationBatchSyncState === 3) {
                commit("setViolationBatchSyncState", 4);
            } else if (state.violationBatchSyncState === 2) {
                commit("setViolationBatchSyncState", 5);
            }
            return { code: 1 };
        } catch (e) {
            commit("appendViolationBatchSyncLog", "查询失败：" + e.message);
            commit("setViolationBatchSyncState", 4);
            return { code: -1, msg: e.message };
        }
    },
    stopViolationBatchSync({ commit, state }) {
        if ([1, 2].includes(state.violationBatchSyncState)) {
            commit("setViolationBatchSyncState", 3);
        }
    },
    async getDetailProduct({ state, commit, dispatch }, index) {
        if (index < 0) return;
        try {
            commit('SET_EDIT_INDEX', index);
            // 先让左侧选中态绘制，再显示右侧 loading
            await new Promise((resolve) => requestAnimationFrame(resolve));
            commit('UPDATE_LOADING', true);
            let pro = state.product[index];
            // 从数据库取 根据itemid和shopid和platform来区分
            const where = {
                itemid: pro.itemId,
            }
            // 平台
            let { platform, type: ptype } = getPlatformBySourceUrl(pro.source_url);
            if (platform) {
                where.platform = platform;
            }
            // 店铺
            let shop = await dispatch('getShop');
            if (shop) {
                where.shopid = shop.id;
            }
            // let has = await IDB.table("productDetail").where(where).get();
            // if (has) {
            //     commit('UPDATE_LOADING', false);
            //     commit('SET_CACHE_DETAIL', {
            //         ...pro,
            //         attr_json: has.attr_json,
            //         source_json_data: has.source_json_data
            //     })
            //     return
            // }
            // 不存在就去远程请求数据
            const tempData = {
                ...pro
            };
            // 从缓存文件中获取数据
            let taobao_aource = await dispatch('getProductSourceJsonData', ptype + '-' + pro.itemId);
            // console.log("@@@@@@@@@@@taobao_aourcev本地缓存", taobao_aource);
            if (taobao_aource?.id) {
                // console.log("从缓存中读取到文件：", taobao_aource);
                if (!taobao_aource?.white_background_image) {
                    taobao_aource.white_background_image = [];
                }
                if (!taobao_aource?.main_images_3_4) {
                    taobao_aource.main_images_3_4 = [];
                }
                if (!taobao_aource?.isLockTitle) {
                    taobao_aource.isLockTitle = false;
                }
                tempData.source_json_data = taobao_aource;
            } else {
                let sourceRes = await dispatch('getSourceJsonData', pro.id);
                console.log("获取线上数据的：", sourceRes)
                if (sourceRes.code == 1 && sourceRes?.info?.source_json_data) {
                    // 淘宝数据
                    const source_json_data = JSON.parse(sourceRes.info.source_json_data);
                    // console.log("source_json_data", source_json_data)
                    // 判断白底图
                    if (!source_json_data?.white_background_image) {
                        source_json_data.white_background_image = [];
                    }
                    if (!source_json_data?.main_images_3_4) {
                        source_json_data.main_images_3_4 = [];
                    }
                    if (!source_json_data?.isLockTitle) {
                        source_json_data.isLockTitle = false;
                    }
                    tempData.source_json_data = source_json_data;
                    // console.log("tempData", tempData);
                } else {
                    Message.error(sourceRes.err || sourceRes.msg || "出错了！");
                }
            }
            // 合并本机用户价锁（不入库；按 itemId 宽松匹配，避免 TXT 重导后 type key 不一致）
            if (tempData.source_json_data?.sku?.skuMap) {
                applyUserPriceLocks(
                    tempData.source_json_data.sku.skuMap,
                    loadUserPriceLocksByItemId(pro.itemId, pro.source_url)
                );
            }
            if (shop) {
                let attrRes = await dispatch('getAttrJson', { cid: pro.cid, shop });
                if (attrRes) {
                    tempData.attr_json = attrRes;
                } else {
                    Message.error(`分类信息加载失败（已自动重试拉取）。cid=${pro.cid || 0}，shopId=${shop?.id || 0}；请重新读取链接或切换店铺后重试。`);
                }
            } else {
                Message.error(`店铺数据异常:${state.selectShop},请重新选择店铺`);
            }

            // 写入数据库
            // await IDB.table("productDetail").put({
            //     ...where,
            //     source_json_data: tempData.source_json_data,
            //     attr_json: tempData.attr_json,
            // });
            // 列表已改过标题、数据包还是旧的：打开编辑时对齐，并锁标题，避免关弹窗把列表标题盖回去
            if (
                tempData.source_json_data &&
                pro.title &&
                tempData.source_json_data.title !== pro.title
            ) {
                tempData.source_json_data.title = pro.title;
                tempData.source_json_data.isLockTitle = true;
            }
            console.log("@@@@@@@@@@@tempData", tempData);
            await new Promise((resolve) => requestAnimationFrame(resolve));
            commit('SET_CACHE_DETAIL', tempData);

            commit('UPDATE_LOADING', false);
        } catch (e) {

        } finally {
            // 即使返回了，也会执行

            // dispatch("nextPreloadNew") // 本地的情况没必要提前预加载
        }
    },
    // 预加载下一个，新版
    async nextPreloadNew({ dispatch, state }) {
        try {
            // 如果当前编辑的索引是最后一个，就不再预加载
            if (state.editIndex >= state.product.length - 1) {
                return;
            }
            let nextPro = state.product[state.editIndex + 1];
            const where = {
                itemid: nextPro.itemId,
            }
            // 平台
            let { platform, type: ptype } = getPlatformBySourceUrl(nextPro.source_url);
            if (platform) {
                where.platform = platform;
            }
            // 店铺
            let shop = await dispatch('getShop');
            if (shop) {
                where.shopid = shop.id;
            }
            let has = await IDB.table("productDetail").where(where).get();
            // 如果存在数据库的话
            if (has) {
                // 直接返回
                return;
            }
            // 不存在就去远程请求数据
            const tempData = {
                ...nextPro
            };
            let sourceRes = await dispatch('getSourceJsonData', nextPro.id);
            if (sourceRes.code == 1 && sourceRes?.info?.source_json_data) {
                // 淘宝数据
                const source_json_data = JSON.parse(sourceRes.info.source_json_data);
                // 判断白底图
                if (!source_json_data?.white_background_image) {
                    source_json_data.white_background_image = [];
                }
                if (!source_json_data?.main_images_3_4) {
                    source_json_data.main_images_3_4 = [];
                }
                tempData.source_json_data = source_json_data;
            } else {
                Message.error(sourceRes.err || sourceRes.msg || "出错了！");
            }

            let attrRes = await dispatch('getAttrJson', { cid: nextPro.cid, shop });
            if (attrRes) {
                tempData.attr_json = attrRes;
            } else {
                Message.error(`分类信息加载失败（已自动重试拉取）。cid=${nextPro.cid || 0}，shopId=${shop?.id || 0}；请重新读取链接或切换店铺后重试。`);
            }

            // 写入数据库
            await IDB.table("productDetail").put({
                ...where,
                source_json_data: tempData.source_json_data,
                attr_json: tempData.attr_json,
            });
        } catch (e) {
            Message.error(`分类信息加载失败：${e?.message || e || "未知错误"}；请重新读取链接或切换店铺后重试。`);
        }
    },
    async getDetailProductOld({ state, commit, dispatch }, index) {
        if (index < 0) return;
        try {
            commit('SET_EDIT_INDEX', index);
            // 开启加载动画
            commit('UPDATE_LOADING', true);
            let pro = state.product[index];
            // 如果存在缓存的话
            if (Cache.has(pro.id)) {
                commit('UPDATE_LOADING', false);
                commit('SET_CACHE_DETAIL', {
                    ...pro,
                    ...Cache.get(pro.id)
                })
                return;
            }
            // 不存在就去远程请求数据
            let res = await dispatch('getDetailProductByApi', pro.id);
            if (res.code == 1 && res.info?.attr_json) {
                const source_json_data = JSON.parse(res.info.source_json_data);

                // 判断白底图
                if (!source_json_data?.white_background_image) {
                    source_json_data.white_background_image = [];
                }
                if (!source_json_data?.main_images_3_4) {
                    source_json_data.main_images_3_4 = [];
                }
                const tempData = {
                    ...pro,
                    attr_json: JSON.parse(res.info.attr_json),
                    change_attribute_json: JSON.parse(res.info.change_attribute_json),
                    source_json_data
                }
                commit('SET_CACHE_DETAIL', tempData);

                Cache.set(pro.id, tempData);
            } else {
                Message.error(res.err || res.msg || "出错了！");
            }

            commit('UPDATE_LOADING', false);
        } catch (e) {

        } finally {
            // 即使返回了，也会执行
            dispatch("nextPreload")
        }
    },
    // 预加载下一个
    async nextPreload({ dispatch, state }) {
        // 如果当前编辑的索引是最后一个，就不再预加载
        if (state.editIndex >= state.product.length - 1) {
            return;
        }
        let nextPro = state.product[state.editIndex + 1];
        // 如果存在缓存的话
        if (Cache.has(nextPro.id)) {
            // 直接返回
            return;
        }
        // 预加载下一个商品
        let res = await dispatch('getDetailProductByApi', nextPro.id);
        if (res.code == 1 && res.info?.attr_json) {
            const source_json_data = JSON.parse(res.info.source_json_data);

            // 判断白底图
            if (!source_json_data?.white_background_image) {
                source_json_data.white_background_image = [];
            }
            if (!source_json_data?.main_images_3_4) {
                source_json_data.main_images_3_4 = [];
            }
            const tempData = {
                ...nextPro,
                attr_json: JSON.parse(res.info.attr_json),
                change_attribute_json: JSON.parse(res.info.change_attribute_json),
                source_json_data
            }

            Cache.set(nextPro.id, tempData);
        } else {
            Message.error(res.err || res.msg || "出错了！");
        }

    },
    getShop: function ({ state, commit, dispatch }) {
        for (let i = 0; i < state.shopList.length; i++) {
            if (state.selectShop == state.shopList[i].id) {
                return state.shopList[i];
            }
        }
        return;
    },

    //多多停止解析
    async stopCaiJiPddProduct({ state, commit, dispatch }) {
        commit('UPDATE_FILED_VALUE', { path: 'readConfig.PDDSTATE', value: 3 })
        let rs = await window.vue.$call.invoke("jProxy.closeProxy");
        commit('UPDATE_FILED_VALUE', { path: 'readConfig.PDDSTATE', value: 0 })
        if (rs) {
            //启动解析成功
            Message.success("停止解析成功");
            return;
        } else {
            Message.error("停止解析失败");
            return;
        }
    },
    //拼多多解析
    async startCaiJiPddProduct({ state, commit, dispatch }) {
        // 避免重复点击
        if (![0, 4, 5].includes(state.readConfig.PDDSTATE)) {
            return;
        }
        let defaultAccount = await dispatch('checkDefaultAccount');
        if (!defaultAccount) {
            return
        }
        commit('RESET_PDD_PRODUCT_DATA');
        // 清理数据库
        await clearIDB(state);

        commit('UPDATE_FILED_VALUE', { path: 'readConfig.PDDSTATE', value: 1 })
        //清理文件目录
        window.vue.$call.sendSync("pddGrab.clearDir");
        // state.pddImportPath = window.vue.$call.sendSync("pddGrab.getCachePath");
        let rs = await window.vue.$call.invoke("jProxy.openProxy");
        if (rs) {
            //启动解析成功
        } else {
            Message.error("启动解析失败");
            return;
        }
    },
    //读取LWX文件
    async startReadLWXProduct({ state, commit, dispatch }) {
        // 避免重复点击
        if (![0, 4, 5].includes(state.readConfig.PDDSTATE)) {
            return;
        }
        let defaultAccount = await dispatch('checkDefaultAccount');
        if (!defaultAccount) {
            return
        }
        if (!state.selectShop) {
            Message.error("请选择抓取店铺");
            return;
        }
        if (!state.selectTemp) {
            Message.error("请先选择模板，选择的模板要跟抓取模板一致，否则会出错");
            return
        }
        let shop = await dispatch('getShop');
        let rs = await window.vue.$call.invoke("winEvent.openDialogNoRead");
        if (rs.code == 1) {
            commit('RESET_PRODUCT_DATA');
            // 清除YKT缓存
            commit("ykt/CLEAR_YKT_WRAPPER", null, { root: true });
            // 清理数据库
            await clearIDB(state);
            commit('UPDATE_FILED_VALUE', { path: 'readConfig.PDDSTATE', value: 1 })
            let rs2 = await window.vue.$call.invoke("lwxGrab.startRun", rs.data.path, shop, state.selectTemp);
            console.log("rs2", rs2);
        } else {
            Message.error("选择导入文件");
            return;
        }
    },
    async startReadPddZipProduct({ state, commit, dispatch }) {
        // 避免重复点击
        if (![0, 4, 5].includes(state.readConfig.PDDSTATE)) {
            return;
        }
        let defaultAccount = await dispatch('checkDefaultAccount');
        if (!defaultAccount) {
            return
        }
        if (!state.selectShop) {
            Message.error("请选择抓取店铺");
            return;
        }
        if (!state.selectTemp) {
            Message.error("请先选择模板，选择的模板要跟抓取模板一致，否则会出错");
            return
        }
        let shop = await dispatch('getShop');
        let rs = await window.vue.$call.invoke("winEvent.openDialogNoRead");
        if (rs.code == 1) {
            let cpath = rs.data.path;
            commit('RESET_PRODUCT_DATA');
            // 清除YKT缓存
            commit("ykt/CLEAR_YKT_WRAPPER", null, { root: true });
            // 清理数据库
            await clearIDB(state);

            commit('UPDATE_FILED_VALUE', { path: 'readConfig.PDDSTATE', value: 1 })
            //第三个参数是模板id
            window.vue.$call.send("pddToProduct.readPathDataByZip", cpath, shop, state.selectTemp);
        } else {
            Message.error("选择导入zip文件失败");
            return;
        }
    },
    //开始读取拼多多
    async startReadPddProduct({ state, commit, dispatch }) {
        // 避免重复点击
        if (![0, 4, 5].includes(state.readConfig.PDDSTATE)) {
            return;
        }
        let defaultAccount = await dispatch('checkDefaultAccount');
        if (!defaultAccount) {
            return
        }
        if (!state.selectShop) {
            Message.error("请选择抓取店铺");
            return;
        }
        if (!state.selectTemp) {
            Message.error("请先选择模板，选择的模板要跟抓取模板一致，否则会出错");
            return
        }
        let shop = await dispatch('getShop');
        let cpath = "";
        if (state.pddImportPath) {
            cpath = state.pddImportPath;
        } else {
            console.log("准备读取目录", new Date())
            let rs = await window.vue.$call.invoke("winEvent.openDirectory");
            console.log("读取目录完毕", new Date())
            if (rs.code == 1) {
                cpath = rs.data.path;
                state.pddFilterId = [];
            } else {
                Message.error("选择目录失败");
                return;
            }
        }
        if (cpath) {
            let filter = JSON.parse(JSON.stringify(state.pddFilterId))
            commit('RESET_PRODUCT_DATA');
            // 清除YKT缓存
            commit("ykt/CLEAR_YKT_WRAPPER", null, { root: true });
            // 清理数据库
            await clearIDB(state);

            commit('UPDATE_FILED_VALUE', { path: 'readConfig.PDDSTATE', value: 1 })
            console.log("调用参数", cpath, shop, filter);
            //第三个参数是模板id
            window.vue.$call.send("pddToProduct.readPathData", cpath, shop, state.selectTemp, filter);
        } else {
            Message.error("选择目录失败");
            return;
        }
    },
    // 开始读取赋值url
    async startReadProduct({ state, commit, dispatch }, catchType = 1) {
        state.catchType = catchType
        if (catchType != 2) {
            state.keepOldImages = {
                main: false,
                sku: false,
                desc: false,
            };
        }
        // 避免重复点击
        if (![0, 4, 5].includes(state.readConfig.STATE)) {
            Message.error("读取任务进行中，请稍后再试");
            return;
        }
        let defaultAccount = await dispatch('checkDefaultAccount');
        if (!defaultAccount) {
            return
        }
        if (!state.selectShop) {
            Message.error("请选择抓取店铺");
            return;
        }
        if (!state.selectTemp) {
            Message.error("请先选择模板");
            return;
        }
        commit('RESET_PRODUCT_DATA');   // 初始化数据
        // 清除YKT缓存
        commit("ykt/CLEAR_YKT_WRAPPER", null, { root: true });
        // 清理数据库
        await clearIDB(state);

        // 新调整
        const lines = state.copyLinkValue.split('\n').map(line => line.trim()).filter(Boolean); // 格式化要抓取的连接，合并成数组

        const uniqueMap = new Map();
        for (const url of lines) {
            try {
                const u = new URL(url);
                let match = null, id = null;
                console.log("@@@@@@@@@@u.host", u.host)
                switch (u.host) {
                    case 'item.taobao.com':
                    case 'detail.tmall.com':
                        match = url.match(/[?&]id=(\d+)/);
                        if (match) {
                            id = match[1];
                            uniqueMap.set('tb_' + id, url);
                        }
                        break;
                    case "detail.1688.com":
                        match = url.match(/offer\/(\d+)\.html/);
                        id = match[1];
                        uniqueMap.set('1688_' + id, url);
                        break;
                    case "fxg.jinritemai.com":
                        match = url.match(/product_id\=(\d+)/);
                        // console.log("---------------------match", match)
                        id = match[1];
                        uniqueMap.set('dy_' + id, url);
                        break;
                    case "mobile.yangkeduo.com":
                        match = url.match(/goods_id=(\d+)/);
                        id = match ? match[1] : null;
                        if (!id) {
                            match = url.match(/[?&]ps=([^&]+)/);
                            id = match ? match[1] : null;
                        }
                        if (id) {
                            uniqueMap.set('pdd_' + id, url);
                        }
                        break;
                    case "mobile.pinduoduo.com":
                        match = url.match(/goods_id=(\d+)/);
                        id = match ? match[1] : null;
                        if (!id) {
                            match = url.match(/[?&]ps=([^&]+)/);
                            id = match ? match[1] : null;
                        }
                        if (id) {
                            uniqueMap.set('pdd_' + id, url);
                        }
                        break;
                }
            } catch (err) {
                console.warn('跳过无法解析的 URL：', url, err.message);
                continue;
            }
        }
        state.readLinkUrls = Array.from(uniqueMap.values());
        if (state.readLinkUrls.length == 0) {
            Message.error("请输入正确的商品链接！");
            return;
        }
        if (state.readLinkUrls.length > 1000) {
            Message.error("最多同时抓取1000条链接，如果需要请前往‘铺货上架🔥’");
            return;
        }
        // 重读默认清除本机 SKU 用户价锁（各 type 兼容 key 一并清）
        const lockKeys = [];
        uniqueMap.forEach((_, key) => {
            const parts = String(key).split("_");
            const id = parts.slice(1).join("_");
            if (!id) return;
            [0, 1, 2, 3, 4, 9].forEach((t) => lockKeys.push(`${t}-${id}`));
        });
        clearUserPriceLocksMany(lockKeys);

        console.log('state.readLinkUrls.length', state.readLinkUrls.length)
        console.log('[读取诊断] startReadProduct', {
            catchType,
            keepOldImages: state.keepOldImages,
            selectShop: state.selectShop,
            selectTemp: state.selectTemp,
            urlCount: state.readLinkUrls.length,
            urls: state.readLinkUrls,
        });

        commit('UPDATE_FILED_VALUE', { path: 'readConfig.STATE', value: 5 });
        try {
            // let res = await Api.post("/admintooltaobaoaccount/addgoodsurl", { url_str: state.copyLinkValue, sys_shop_id: state.selectShop });
            // if (res.code == 1) {
            // 只有状态是5， 准备开始执行，才执行
            if (state.readConfig.STATE == 5) {
                commit('UPDATE_FILED_VALUE', { path: 'readConfig.TOTAL', value: state.readLinkUrls.length });

                // 统计数量
                commit('UPDATE_FILED_VALUE', { path: 'readConfig.STATE', value: 1 }); // 标记开始执行
                console.log('[读取诊断] readConfig.STATE -> 1，worker开始抓取');
            }
            // }
            // else {
            //     Message.error(res.err || res.msg || "出错了！");
            // }
        } catch (e) {
            commit('UPDATE_FILED_VALUE', { path: 'readConfig.STATE', value: 0 });
            Message.error("执行过程中出现错误：" + e.message);
        }
    },
    //重试失败的拷贝
    // async retryCopyProduct({ commit, dispatch }, products) {
    //     console.log("重试上架");
    //     const value = {
    //         ...getBaseConfig(),
    //         STATE: 1
    //     };
    //     commit('UPDATE_FILED_VALUE', { path: 'copyConfig', value });
    //     commit('UPDATE_FILED_VALUE', { path: 'copyProductIds', value: products });
    //     //启动起来
    //     window.vue.$call.send("douDianNewPublish.start");
    // },
    hasCopy: function ({ state, commit, dispatch }, { gid, shopid }) {
        // console.log("hasCopy", gid, shopid)
        let products = state.product;
        // console.log("=========products",products)
        for (let i = 0; i < products.length; i++) {
            let product = products[i];
            if (gid == product.id) {
                // console.log("===找到gid", gid,"shopid:",shopid)
                const oldList = product.statusList || [];
                // console.log("=====",oldList)
                const statusIndex = oldList.findIndex(s => shopid == s.shopid);
                if (statusIndex == -1) {
                    //这种就是要重试的-需要重新上架
                    // console.log("这种就是要重试的-需要重新上架")
                    return true;
                } else {
                    const status = oldList[statusIndex];
                    if (status.status == 1) {
                        // 成功场景下：仅当“店铺 + 模板”都与上一次一致时，才拦截并提示“全部成功”
                        // 若模板已切换，允许重新提交上架
                        const backupItem = (state.copyProductIdsBackup || []).find(
                            item => String(item.gid) === String(gid) && String(item.shopid) === String(shopid)
                        );
                        const currentTemplateId = String(state.selectTemp || "");
                        const backupTemplateId = String(backupItem?.dou_template_id || "");
                        if (backupItem && currentTemplateId && backupTemplateId && currentTemplateId !== backupTemplateId) {
                            return true;
                        }
                        return false;
                    } else {
                        // console.log("失败需要重新上架", product)
                        //失败需要重新上架
                        return true
                    }
                }
            }
        }
        return true;
    },
    areObjectArraysEqual({ state, commit, dispatch }, data) {
        const arr1 = data.a;
        const arr2 = data.b;
        const fields = data.fields;
        if (arr1.length !== arr2.length) return false;
        // 取出对象中指定字段构成简化对象，再转字符串
        const simplify = obj => JSON.stringify(
            fields.reduce((acc, f) => {
                acc[f] = obj[f];
                return acc;
            }, {})
        );

        const set1 = new Set(arr1.map(simplify));
        const set2 = new Set(arr2.map(simplify));

        if (set1.size !== set2.size) return false;

        for (const item of set1) {
            if (!set2.has(item)) return false;
        }
        return true;
    },
    async resetProductStatusByNewData({ state, commit, dispatch }, data) {
        let result = [];
        for (let i = 0; i < data.goodsids.length; i++) {
            for (let j = 0; j < data.shopids.length; j++) {
                let gid = data.goodsids[i];
                let sid = data.shopids[j].id;
                result.push({
                    gid: gid,
                    shopid: sid,
                    dou_template_id: data.selectTemp,
                })
            }
        }
        let rs = await dispatch("areObjectArraysEqual", { a: result, b: state.copyProductIdsBackup, fields: ["gid", "shopid", "dou_template_id"] })
        if (rs) {
            //跟上一次数据一摸一样没变化
            commit("RESET_PRODUCT_STATUS_BY_NEWDATA");
        } else {
            //数据发生改变了---重置状态
            commit("RESET_PRODUCT_STATUS");
        }

    },
    async startCopyProduct({ commit, dispatch }, { goodsids, shopids }) {
        let defaultAccount = await dispatch("checkDefaultAccount");
        if (!defaultAccount) {
            return
        }
        // console.log("goodsids", goodsids, "shopids", shopids);
        let count = goodsids.length * shopids.length;
        if (count > 30000) {
            Message.error("您复制的商品数量超过30000,算法是:【上架宝贝数】x【店铺数量】请减少复制数量");
            return
        }
        // let template = await dispatch('checkDefaultTemplate');
        // if (!template) {
        //     return;
        // }
        // 判断模板
        if (!state.selectTemp) {
            Message.error("请先选择模板，选择的模板要跟抓取模板一致，否则会出错");
            return
        }
        // console.log("template",template);
        // commit("RESET_PRODUCT_STATUS")
        await dispatch("resetProductStatusByNewData", { goodsids, shopids, selectTemp: state.selectTemp });
        commit('UPDATE_FILED_VALUE', { path: 'copyConfig.STATE', value: 5 });
        try {
            const result = []
            const result2 = []
            for (let i = 0; i < goodsids.length; i++) {
                let gid = goodsids[i];
                let find = state.product.find(pro => pro.id == gid);
                for (let j = 0; j < shopids.length; j++) {
                    let shopInfo = shopids[j];
                    let find2 = result.find(pro2 => (pro2.gid == gid && pro2.shopid == shopInfo.id));
                    if (!find2) {
                        let hasCopy = await dispatch('hasCopy', { gid: gid, shopid: shopInfo.id });
                        if (hasCopy) {
                            console.log("=========要上架", find?.itemId, state.selectTemp)
                            result.push({
                                rid: 0,
                                gid: gid,
                                shopid: Number(shopInfo.id) || 0,
                                shop_name: shopInfo.shop_name,
                                itemId: find?.itemId || 0,
                                change_attribute_json: find?.change_attribute_json || null,
                                dou_item_id: 0,  //抖店宝贝id
                                // dou_template_id: template.id,  //模板id
                                dou_template_id: state.selectTemp,  //模板id
                            });
                        }
                        result2.push({
                            gid: gid,
                            shopid: shopInfo.id,
                            dou_template_id: state.selectTemp,
                        })
                    }
                }
            }
            if (result.length == 0) {
                Message.error("您要上架的商品已经全部都是成功的");
                commit('UPDATE_FILED_VALUE', { path: 'copyConfig.STATE', value: 0 });
                return
            }
            const value = {
                ...getBaseConfig(),
                STATE: 1
            };
            // console.log("result", JSON.parse(JSON.stringify(result)))
            commit('UPDATE_FILED_VALUE', { path: 'copyConfig', value });
            commit('UPDATE_FILED_VALUE', { path: 'copyProductIds', value: result });
            commit('UPDATE_FILED_VALUE', { path: 'copyProductIdsBackup', value: result2 });
            commit('UPDATE_FILED_VALUE', { path: 'copyProductIdsIsFinish', value: true });
            //启动起来
            //douDianNewPublish
            window.vue.$call.send("douDianNewPublishV2.start");
            console.log("点击拷贝了");
        } catch (e) {
            commit('UPDATE_FILED_VALUE', { path: 'copyConfig.STATE', value: 0 });
            Message.error("执行过程中出现错误：" + e.message);
        }
    },
    async getDetailProductByApi({ commit }, id) {
        return Api.post("/admintooltaobaoaccount/goodsdetails", { id })
    },
    // 获取淘宝结构数据
    async getSourceJsonData({ commit }, id) {
        return Api.post("/admintooltaobaoaccount/goodssourcejsondata", { id })
    },
    async getProductSourceJsonData({ commit }, type_itemid) {
        const rs = await Call.invoke("productCacheFile.readSourceJson", type_itemid);
        if (rs?.code == 1) {
            return rs.data;
        }
        return null;
    },
    async setProductSourceJsonData({ commit }, { type_itemid, data }) {
        return Call.invoke("productCacheFile.writeSourceJson", type_itemid, data);
    },
    /**
     * AI换图采用后：写本机数据包 + 排队同步到「用户自己的商品库」(goodsdetailsedit)。
     * 只改 publish_url 用户库，不写公用商品库(tool_all_goods)，避免污染公共数据。
     */
    async syncUserProductSourceJsonAfterAiReplace({ commit, dispatch }, { product, type_itemid, source }) {
        if (!product?.id || !source) {
            return { code: -1, msg: "缺少商品或数据包，无法同步用户商品库" };
        }
        const source_json_data = {
            ...source,
            title: source.title != null && source.title !== "" ? source.title : product.title,
        };
        const typeIds = [];
        const pushTypeId = (id) => {
            if (id && !typeIds.includes(id)) typeIds.push(id);
        };
        pushTypeId(type_itemid);
        if (product.itemId) {
            pushTypeId(`1-${product.itemId}`);
            const { type: ptype } = getPlatformBySourceUrl(product.source_url);
            if (ptype) {
                pushTypeId(ptype + "-" + product.itemId);
            }
        }
        for (const tid of typeIds) {
            await dispatch("setProductSourceJsonData", {
                type_itemid: tid,
                data: source_json_data,
            });
        }
        const remoteSourceJson = stripSourceJsonForRemote(source_json_data);
        const img0 = source_json_data?.images?.[0];
        const pic =
            typeof img0 === "string"
                ? img0
                : img0?.url || img0?.image || img0?.pic || img0?.img || "";
        const params = {
            id: product.id,
            source_json_data: JSON.stringify(remoteSourceJson),
            source_title: product.title || source_json_data.title || "",
        };
        if (pic) {
            params.source_goods_image = pic;
        }
        commit("UPDATE_PRODUCT_SAVE_STATUS_BY_ID", {
            id: product.id,
            value: 1,
        });
        // 只排队同步用户商品库；列表缩略图由调用方 $set(product.pic)，避免 UPDATE_PRODUCT_BY_ID 误清空 title
        SaveProductQueue.add(params, "save", commit);
        return { code: 1 };
    },
    /**
     * 导入/读取成功入列表前：用本机用户价锁重算 change_price，避免 TXT 重导后列表价丢手改
     * 先叠列表区间（不依赖缓存 IPC），再尽量写回 source_json 供鉴图一致
     */
    async applyLocalUserLocksToListProduct({ dispatch }, product) {
        if (!product || product.status != 1 || !product.itemId) {
            return product;
        }
        const locks = loadUserPriceLocksByItemId(product.itemId, product.source_url);
        if (!locks || Object.keys(locks).length === 0) {
            return product;
        }
        // 1) 列表售价：锁价并进 min/max（不依赖本地缓存是否已写入 calcPrice）
        const lockPrices = Object.values(locks)
            .map((l) => parseFloat(l.calcPrice))
            .filter((n) => !isNaN(n));
        if (lockPrices.length) {
            const curMin = parseFloat(product.change_price_min);
            const curMax = parseFloat(product.change_price_max);
            const all = [
                ...lockPrices,
                ...(isNaN(curMin) ? [] : [curMin]),
                ...(isNaN(curMax) ? [] : [curMax]),
            ];
            product.change_price_min = Math.min(...all);
            product.change_price_max = Math.max(...all);
        }
        // 2) 写回本机 source_json，打开人工鉴图时与列表一致
        try {
            const { type: ptype } = getPlatformBySourceUrl(product.source_url);
            const typeId =
                typeItemIdFromPtype(ptype, product.itemId) ||
                getTypeItemId(product.source_url, product.itemId) ||
                `1-${product.itemId}`;
            let source = await dispatch("getProductSourceJsonData", typeId);
            if (!source?.sku?.skuMap) {
                source = await dispatch("getProductSourceJsonData", `1-${product.itemId}`);
            }
            if (source?.sku?.skuMap) {
                applyUserPriceLocks(source.sku.skuMap, locks);
                const prices = Object.values(source.sku.skuMap)
                    .map((s) => parseFloat(s.calcPrice != null ? s.calcPrice : s.salePrice))
                    .filter((n) => !isNaN(n));
                if (prices.length) {
                    product.change_price_min = Math.min(...prices);
                    product.change_price_max = Math.max(...prices);
                }
                await dispatch("setProductSourceJsonData", {
                    type_itemid: typeId,
                    data: source,
                });
                if (typeId !== `1-${product.itemId}`) {
                    await dispatch("setProductSourceJsonData", {
                        type_itemid: `1-${product.itemId}`,
                        data: source,
                    });
                }
            }
        } catch (e) {
            console.warn("applyLocalUserLocksToListProduct", e);
        }
        return product;
    },
    async onReadPddProduct({ commit, dispatch }, product) {
        if (product?.status == 1) {
            product = await dispatch("applyLocalUserLocksToListProduct", product);
        }
        commit("updateReadPddProduct", product);
    },
    async onWangProductUpdate({ commit, dispatch }, input) {
        let product = input?.product;
        if (product && (product.status == 1 || product.change_price_min != null)) {
            product = await dispatch("applyLocalUserLocksToListProduct", {
                ...product,
                status: product.status != null ? product.status : 1,
            });
            input = { ...input, product };
        }
        commit("updateWangCount", input);
    },
    // 获取分类结构数据
    async getAttrJson({ state }, payload) {
        //  cache/doudian/attr_json/${cid}-${shopId}
        // 兼容旧调用方式：dispatch('getAttrJson', 'cid-shopId')
        let cid_sys_shop_id = "";
        let cid = 0;
        let shop = null;
        let shopId = 0;
        if (typeof payload === "string") {
            cid_sys_shop_id = payload;
        } else if (payload && typeof payload === "object") {
            cid = parseInt(payload.cid, 10);
            shop = payload.shop || null;
            shopId = parseInt(payload.shopId || shop?.id || 0, 10);
            cid_sys_shop_id = `${cid}-${shopId}`;
        }

        let rs = await Call.invoke("productCacheFile.readAttrJson", cid_sys_shop_id);
        if (rs?.code == 1 && rs.data) {
            return rs.data;
        }

        // 缓存不存在/损坏：自动从 worker 拉一次类目属性并写回缓存
        // 需要 shop 对象，否则只能返回空交给上层提示
        if (!shop) {
            shop = (state.shopList || []).find((it) => String(it.id) === String(shopId)) || null;
        }
        if (!shop || !cid || cid <= 0) {
            return null;
        }
        try {
            let schemaRs = await window.vue?.$call?.invoke(
                "douDianBatchOperationProduct.getCategoryAttributeSchema",
                shop,
                cid,
            );
            if (!schemaRs || schemaRs.code != 1 || !Array.isArray(schemaRs.data) || schemaRs.data.length === 0) {
                return null;
            }
            await Call.invoke("productCacheFile.writeAttrJson", cid_sys_shop_id, schemaRs.data);
            return schemaRs.data;
        } catch (e) {
            return null;
        }
    },
    async updateProductDetail({ commit, dispatch }, data) {
        // 如果当前编辑的商品被删除的情况下
        if (!data?.id || !data?.attr_json) {
            return;
        }
        // 让出主线程，避免切换商品时同步序列化大对象导致页面卡顿
        await new Promise((resolve) => setTimeout(resolve, 0));
        const source_json_data = {
            ...data.source_json_data,
            title: data.title
        }
        // 新版多店鉴图旁路：随 source_json_data 一起持久化
        if (data.ai_polish_overlays && typeof data.ai_polish_overlays === "object") {
            source_json_data.__ai_polish_overlays = data.ai_polish_overlays;
        } else if (data.source_json_data?.__ai_polish_overlays) {
            source_json_data.__ai_polish_overlays = data.source_json_data.__ai_polish_overlays;
        }
        // 商品库提交干净 JSON（不含本机用户价锁/引流预览）
        const remoteSourceJson = stripSourceJsonForRemote(source_json_data);
        const pramas = {
            id: data.id,
            source_json_data: JSON.stringify(remoteSourceJson),
            change_attribute_json: JSON.stringify(data.change_attribute_json),
            attr_json: JSON.stringify(data.attr_json),
            source_title: data.title
        }
        // 传主图
        if (source_json_data?.images?.[0]) {
            pramas.source_goods_image = source_json_data.images[0];
        }
        // 重新设置值，避免读取数据库中读到旧数据
        const where = {
            itemid: data.itemId,
        }
        // 平台
        let { platform, type: ptype } = getPlatformBySourceUrl(data.source_url);
        if (platform) {
            where.platform = platform;
        }
        // 店铺
        let shop = await dispatch('getShop');
        if (shop) {
            where.shopid = shop.id;
        }
        // 本机缓存保留含锁完整数据，便于本机再打开
        await dispatch("setProductSourceJsonData", { type_itemid: ptype + '-' + data.itemId, data: source_json_data });
        commit("UPDATE_PRODUCT_SAVE_STATUS_BY_ID", {
            id: data.id,
            value: 1,
        });
        SaveProductQueue.add(pramas, 'save', commit);
        commit("UPDATE_PRODUCT_BY_ID", {
            id: data.id,
            result: {
                title: data.title,
                classify_str: data.classify_str,
                change_attribute_json: data.change_attribute_json,
                cid: data.cid
            }
        })

        // let res = await Api.post("/admintooltaobaoaccount/goodsdetailsedit", pramas)
        // if (res.code == 1) {
        //     // let has = await IDB.table("productDetail").where(where).get();
        //     // if (has) {
        //     //     await IDB.table("productDetail").put({ ...has, source_json_data: data.source_json_data });
        //     // }
        //     commit("UPDATE_PRODUCT_BY_ID", {
        //         id: data.id,
        //         result: {
        //             title: data.title,
        //             classify_str: data.classify_str,
        //             change_attribute_json: data.change_attribute_json,
        //         }
        //     })
        // } else {
        //     Message.error(res.err || res.msg || "出错了！");
        // }
        return true;
    },
    /**
     * 精细化上架列表直接改标题。
     * 与编辑弹窗一致：写入 source_json.title、isLockTitle=true、change_title。
     * 不预测类目；上架时按最终标题再预测。已锁住商品不改。
     */
    async saveListTitle({ state, commit, dispatch }, { id, title, prevTitle }) {
        const findIndex = state.product.findIndex((item) => item.id == id);
        if (findIndex < 0) {
            return { code: -1, msg: "商品不存在" };
        }
        const row = state.product[findIndex];
        if (Number(row.is_lock_source_json_data) === 1) {
            return { code: -1, msg: "商品已锁住，不能修改标题" };
        }
        title = clampTitleByte(title);
        if (!String(title).trim()) {
            return { code: -1, msg: "标题不能为空" };
        }
        if (prevTitle != null && title === prevTitle) {
            return { code: 1, skip: true };
        }
        const seq = (listTitleSaveSeq.get(id) || 0) + 1;
        listTitleSaveSeq.set(id, seq);
        const stale = () => listTitleSaveSeq.get(id) !== seq;

        const editing =
            state.cacheDetail &&
            state.cacheDetail.id == id &&
            state.cacheDetail.source_json_data;
        let source = null;
        if (editing) {
            source = {
                ...state.cacheDetail.source_json_data,
                title,
                isLockTitle: true,
            };
        } else {
            const { type: ptype } = getPlatformBySourceUrl(row.source_url);
            const typeId =
                typeItemIdFromPtype(ptype, row.itemId) ||
                getTypeItemId(row.source_url, row.itemId);
            source = typeId ? await dispatch("getProductSourceJsonData", typeId) : null;
            if (!source || (source.title == null && source.oldTitle == null && !source.id)) {
                const sourceRes = await dispatch("getSourceJsonData", row.id);
                if (stale()) {
                    return { code: 1, skip: true };
                }
                if (sourceRes?.code == 1 && sourceRes?.info?.source_json_data) {
                    try {
                        source = JSON.parse(sourceRes.info.source_json_data);
                    } catch (e) {
                        source = null;
                    }
                }
            }
            if (!source) {
                return { code: -1, msg: "读取商品数据失败，标题未保存" };
            }
            source = {
                ...source,
                title,
                isLockTitle: true,
            };
            if (typeId) {
                await dispatch("setProductSourceJsonData", {
                    type_itemid: typeId,
                    data: source,
                });
            }
        }
        if (stale()) {
            return { code: 1, skip: true };
        }

        if (editing) {
            const nextDetail = {
                ...state.cacheDetail,
                title,
                source_json_data: source,
            };
            commit("SET_CACHE_DETAIL", nextDetail);
            if (nextDetail.attr_json) {
                await dispatch("updateProductDetail", nextDetail);
                return { code: 1 };
            }
            const { type: ptype } = getPlatformBySourceUrl(row.source_url);
            const typeId =
                typeItemIdFromPtype(ptype, row.itemId) ||
                getTypeItemId(row.source_url, row.itemId);
            if (typeId) {
                await dispatch("setProductSourceJsonData", {
                    type_itemid: typeId,
                    data: source,
                });
            }
        }

        const remoteSourceJson = stripSourceJsonForRemote(source);
        commit("UPDATE_PRODUCT_SAVE_STATUS_BY_ID", {
            id,
            value: 1,
        });
        SaveProductQueue.add(
            {
                id: row.id,
                source_json_data: JSON.stringify(remoteSourceJson),
                source_title: title,
            },
            "save",
            commit
        );
        commit("UPDATE_PRODUCT_BY_ID", {
            id,
            result: {
                title,
                classify_str: row.classify_str,
            },
        });
        return { code: 1 };
    },
    async updateProductDetailOld({ commit }, data) {
        // 如果当前编辑的商品被删除的情况下
        if (!data?.id) {
            return;
        }
        const source_json_data = {
            ...data.source_json_data,
            title: data.title
        }
        const pramas = {
            id: data.id,
            change_attribute_json: JSON.stringify(data.change_attribute_json),
            source_json_data: JSON.stringify(source_json_data),
            source_title: data.title
        }
        // 传主图
        if (source_json_data?.images?.[0]) {
            pramas.source_goods_image = source_json_data.images[0];
        }

        let res = await Api.post("/admintooltaobaoaccount/goodsdetailsedit", pramas)
        if (res.code == 1) {
            // 重新设置值，避免读取缓存数据读到旧数据
            Cache.set(data.id, data);

            commit("UPDATE_PRODUCT_BY_ID", {
                id: data.id,
                result: {
                    title: data.title,
                    classify_str: data.classify_str
                }
            })
        } else {
            Message.error(res.err || res.msg || "出错了！");
        }
        return true;
    },
    async checkDefaultAccount() {
        let res = await Api.post("/admintooltaobaoaccount/getdefaultaccount");
        if (res.code) {
            return true;
        } else {
            Message.error(res.err);
        }
        return false;
    },
    async checkDefaultTemplate() {
        let res = await Api.post("/admintooltaobaoaccount/getdefaulttemplate");
        if (res.code == 1) {
            return res.info;
        } else {
            Message.error(res.err);
        }
        return false;
    },
    async getShopList({ commit, state }, refresh) {
        console.log("refresh", refresh, "state", state)
        if (state.shopList.length > 0 && !refresh) {
            console.log("----走了不取")
            return; // 如果已经有店铺列表了，就不再请求
        }
        // 与店铺列表统一：按本地登录态筛已登录店（线上 is_login 不可信）
        let res = await fetchDouDianAccounts(Api.post.bind(Api), {
            requireLogin: true,
            status: 1,
            pageSize: 1000,
        });
        if (res.code == 1) {
            const arr = res.list?.map(it => {
                return {
                    ...it,
                    id: it.id + ''
                }
            }) || [];
            commit('SET_SHOP_LIST', arr);
        }
    },
    // 获取模板列表
    async getTemplateList({ commit, state }) {
        let res = await Api.post("/admintooltaobaoaccount/getgoodstemplatelist", {
            page: 1,
            pageSize: 100,
        });
        if (res.code == 1) {
            commit('UPDATE_FILED_VALUE', { path: 'tempList', value: res.list || [] });
        }
    },
    // 获取抓取队列
    async getReadUrls({ commit, state }) {
        if (state.readLinkUrls.length == 0) {
            return null;
        }

        const url = state.readLinkUrls[0];

        commit("REOMVE_FIRST_ITEM", 'readLinkUrls');
        return url;
    },
    // 获取上架关系表id
    async getCopyIds({ commit, state }) {
        if (state.copyProductIds.length == 0) {
            return null;
        }

        const id = state.copyProductIds[0];

        commit("REOMVE_FIRST_ITEM", 'copyProductIds');
        return id;
    },
    /**
     * 限时限量购·创建活动（进度与结果写入本模块 state，与商机提报一样不依赖页面实例存活）
     */
    async runFlashsaleCreate({ commit, state }, payload) {
        const Call = (await import("@/script/call")).default;
        const Message = (await import("@/script/Message")).default;
        const { runFlashsaleCreateRunner } = await import(
            "@/script/flashsaleCreateRunner"
        );
        if (state.flashsalestate === 2) {
            Message.warning("创建活动任务进行中，请稍候");
            return;
        }
        commit("setFlashsaleCreateDialogVisible", true);
        commit("setFlashsaleState", 2);
        try {
            const { failReasons, stopped } = await runFlashsaleCreateRunner({
                commit,
                productState: state,
                Call,
                Message,
                mShopList: payload.mShopList,
                localDateRange: payload.localDateRange,
                helpers: payload.helpers,
            });
            const okN = state.flashsaleCreateSuccessCount;
            const failN = state.flashsaleCreateFailCount;
            const totalN = state.flashsaleCreateProgressTotal;
            const doneN = state.flashsaleCreateProgressDone;
            const remain = Math.max(0, totalN - doneN);
            const summary = `创建完成：成功 ${okN} 件，失败 ${failN} 件`;
            const detail = [...new Set(failReasons.filter(Boolean))].join("；");
            if (stopped) {
                Message.warning(
                    remain > 0
                        ? `已停止创建：${summary}；尚有约 ${remain} 件未处理。`
                        : `已停止创建：${summary}。`,
                );
            } else if (failN && detail) {
                Message({
                    type: okN ? "warning" : "error",
                    duration: 10000,
                    showClose: true,
                    message: `${summary}。原因：${detail}`,
                });
            } else {
                Message.success(summary);
            }
        } finally {
            commit("setFlashsaleState", 0);
            commit("setFlashsaleCreateStopRequested", false);
        }
    },
};

const getters = {
    getBatchEditShortTitlesStatus(state) {
        return state.shorttitlestate;
    },
    getBatchEditCategoryAttrsStatus(state) {
        return state.attrstate;
    },
    getBatchEditFabricStatus(state) {
        return state.fabricstate;
    },
    getBatchEditFreightStatus(state) {
        return state.freightstate;
    },
    getBatchEditBrandsStatus(state) {
        return state.brandstate;
    },
    getBatchEditAftersaleStatus(state) {
        return state.aftersalestate;
    },
    getBanJiaStatus(state) {
        return state.banJiaStatus;
    },
    getShangjiStatus(state) {
        return state.shangjistate;
    },
    getShangJiCollectStatus(state) {
        return state.shangJiCollectState;
    },
    getBatchEditTitlesStatus(state) {
        return state.titlestate;
    },
    getBatchEditSkuPricesStatus(state) {
        return state.skuPricestate;
    },
    getBatchPreviewSkuPricesStatus(state) {
        return state.skuPricePreviewState;
    },
    getBatchOfflineDeleteStatus(state) {
        return state.offlineDeleteState;
    },
    getDraftsWebReleaseStatus(state) {
        return state.draftsWebReleaseState;
    },
    getDraftsSyncStatus(state) {
        return state.draftsSyncState;
    },
    getDeadStockAnalyzeStatus(state) {
        return state.deadStockAnalyzeState;
    },
    getDeadStockBatchStatus(state) {
        return state.deadStockBatchState;
    },
    getLowQualityFetchStatus(state) {
        return state.lowQualityFetchState;
    },
    getLowQualityBatchStatus(state) {
        return state.lowQualityBatchState;
    },
    getQualityDiagnoseFetchStatus(state) {
        return state.qualityDiagnoseFetchState;
    },
    getQualityDiagnoseBatchStatus(state) {
        return state.qualityDiagnoseBatchState;
    },
    getFlashsaleStatus(state) {
        return state.flashsalestate;
    },
    getCopyProductIds(state) {
        let cpy = JSON.parse(JSON.stringify(state.copyProductIds))
        let all = cpy.splice(0);
        return all
    },
    getOnOff(state) {
        return state.copyConfig.STATE
    },
    getPddOnOff(state) {
        return state.readConfig.PDDSTATE
    },
    getWangOnOff(state) {
        return state.readConfig.STATE
    },
    getWangConfig(state) {
        return state.readConfig
    },
    getWangInitQueue(state) {
        let shop
        for (let i = 0; i < state.shopList.length; i++) {
            if (state.selectShop == state.shopList[i].id) {
                shop = state.shopList[i]
                break
            }
        }
        return {
            shop: shop,
            selectShop: state.selectShop,
            catchType: state.catchType,
            keepOldImages: state.keepOldImages || {
                main: false,
                sku: false,
                desc: false,
            },
        }
    },
    getCopyReadLinkUrls(state) {
        let all = state.readLinkUrls.splice(0);
        return all
    },
    getDefaultTemplate() {
        return state.selectTemp
    },
    //抓取成功的id
    getCopySuccessIds(state) {
        const ids = state.product.map(item => item.id);
        return ids
    },
    //抓取失败的id
    getCopyJumpIds(state) {
        const ids = state.jumpProduct.map(item => item.id);
        return ids
    },
};

//  创建基础配置
function getBaseConfig(fileName) {
    return {
        SUCCESS_ACOUNT: 0,          //成功条数
        FAIL_ACOUNT: 0,             //失败条数
        AWAIT_ACOUNT: 0,            //等待条数
        TOTAL: 0,                   //总的条数
        STATE: 0,                   //1 准备开始 2 运行中 3点击暂停 0.未开始 4.完成, 5点击开始 6.点击停止 7.node停下来了
        PDDSTATE: 0,                //1 准备开始 2 运行中 3点击暂停 0.未开始 4.完成, 5点击开始 
        FILE_NAME: fileName || "",  //文件名 读取文件 read  复制文件copy
    }
}

async function clearIDB(state) {
    try {
        if (state.selectShop) {
            const shop = state.shopList.find(it => it.id == state.selectShop);
            if (shop) {
                await IDB.table("productDetail").where({ shopid: shop.id }).deleteAll();
            }
        } else {
            await IDB.table("productDetail").clear();
        }
    } catch (e) {
        console.error("数据库清除失败", e);
    }
}

function getPlatformBySourceUrl(url) {
    const platformTypes = {
        "taobao": 1,
        "1688": 2,
        "pdd": 3,
        "dy": 4,
    }
    let platform = "";
    if (url) {
        try {
            const u = new URL(url);
            switch (u.host) {
                case 'item.taobao.com':
                case 'detail.tmall.com':
                    platform = 'taobao';
                    break;
                case "detail.1688.com":
                    platform = "1688";
                    break;
                case "fxg.jinritemai.com":
                    platform = "dy";
                    break;
                case "mobile.yangkeduo.com":
                    platform = "pdd"
                    break;
                case "mobile.pinduoduo.com":
                    platform = "pdd"
                    break;
            }
        } catch (err) {
            console.warn('跳过无法解析的 URL：', url, err.message);
        }
    }
    return {
        platform,
        type: platformTypes[platform] || 0
    };
}

export default {
    namespaced: true, // 推荐开启命名空间
    state,
    mutations,
    actions,
    getters,
};
